$(function() {
    initBucksCurrencyEventListener();
    toggleCartDrawerNotice();
    toggleMenu();
    destroyDesktopPdpMediaSlider();
    initComplementarySlider();
    checkIncompleteBundle();
    initPdpHighlightSlider();
    updateAppBundleButton();
    updatePdpBundlePrice();
    performRecommendations();
    updateBundleSliderHeight();
    initStickyAtcWatcher();
    initSizeGuideSplide();
    updateCharmLimit();
    updateCharmOverlayImage();
    initProductTabsAnchorLinks();
    initProductTileSwatchClick();
    initProductTileSwatchSelection();
    initProductTileTouchReveal();
    initAlignProductGridTitleRows();
    wishlistPageStyling();
    bindCheckoutInterceptor();
    initCartGwpCheckoutSync();
    bindBundleMeasurementsModal();
    if ($('.jsc-product-bundle').length) {
      recalculateAllBundlesPrice();
    }

    document.addEventListener('theme:cart:change', function() {
        performRecommendations();
        masterPromo();
    });
    $(window).on('load', function () {
        masterPromo();
        alignProductGridTitleRows();
    });

    setTimeout(() => {
      calculateCharmSetBundlePrice();
    }, 500);

    setTimeout(() => {
      initBucksCurrencyDetection();
    }, 1500);
});

// start: product highlights
initPdpHighlightSlider = () => {
    var $slider = $('.jsc-product-highlight-wrapper').find('.jsc-product-highlight');
    if($slider.length > 0) {
        var itemCount = $slider.find('.jsc-product-highlight-item').length;
        var windowWidth = $(window).width();

        if ((windowWidth <= 480 && itemCount > 3) || itemCount > 4) {
            $slider.removeClass('d-flex');
            $slider.flickity({
                prevNextButtons: false,
                pageDots: false,
                cellAlign: 'left',
                contain: true,
                wrapAround: false
            });
        }

    }
}

showHighlightPopup = (evt) => {
    var index = $(evt).find('.jsc-highlight-media-thumbnail').attr('data-index');
    var $popup = $('.jsc-product-highlight-popup[data-index="' + index + '"]');
    
    if($popup.length > 0) {
        var $allPopup = $('.jsc-product-highlight-popup');
        $allPopup.removeClass('active');
        $popup.find('.jsc-highlight-media-full')[0].currentTime = 0;
        $popup.addClass('active');
        $('#jsc-custom-chat-widget').addClass('hide-important');
        $popup.find('.jsc-highlight-media-full')[0].play();
        $popup.find('.jsc-highlight-media-full').prop('muted', false);
    }
}

updateHighlightPopupPosition = () => {
    var $container = $('#main .container');
    if($(window).width() > 1024 && $container.length > 0) {
        var containerRight = $('#main .container')[0].getBoundingClientRect().right;
        var containerPadding = parseInt($('#main .container').css('padding-right'));
        var windowWidth = $(window).width();
        if(containerRight < windowWidth) {
            var rightPos = windowWidth - containerRight + containerPadding;
            $('.jsc-product-highlight-popup').css('right', rightPos + 'px');
        }
    }
    
}

hideHighlightPopup = (evt) => {
    var $popup = $(evt).parent();
    $popup.removeClass('active');
    $('#jsc-custom-chat-widget').removeClass('hide-important');

    var $video = $popup.find('.jsc-product-highlight-media-popup video');
     if ($video.length > 0) {
        $video.prop('muted', true);
    }
}
// end: product highlights

// start: show megamenu on hover
toggleMenu = () => {
    var $menuButton = $('.jsc-menu-button');
    var $megamenu = $('.jsc-megamenu');

    if ($menuButton.length > 0) {
        $menuButton.on('mouseenter', function() {
            var counter = $(this).attr('data-counter');
            showMenu(counter, $(this));
            $('#headerContainer .logo-image .jsc-overlay_logo').addClass('opacity-100');
            $('#headerContainer .logo-image .jsc-overlay_logo').removeClass('opacity-0');
        });

        $megamenu.on('mouseleave', function() {
            closeMenu();
            $('#headerContainer .logo-image .jsc-overlay_logo').addClass('opacity-0');
            $('#headerContainer .logo-image .jsc-overlay_logo').removeClass('opacity-100');
        });
    }
}

showMenu = (counter, button) => {
    var $megamenu = $(button).siblings('.jsc-megamenu');
    var $header = $('.shopify-section-group-header-group data-island');

    if ($megamenu.length > 0) {
        closeMenu();
        $header.attr('data-color-scheme', 'scheme6');
        $header.addClass('bg-scheme-background');
        $header.removeClass('bg-scheme-background/0');
        $megamenu.show();
        $(button).find('.svg-scale').addClass('rotate-180');
    }
}

closeMenu = () => {
    var $megamenu = $('.jsc-megamenu');
    var $menuButton = $('.jsc-menu-button');
    var $header = $('.section-site-header data-island');
    var isSticky = $('.section-site-header').attr('is-sticky-active');

    if ($megamenu.length > 0) {
        if (window.location.pathname === '/' && isSticky == 'false') {
            console.log('run');
            $header.attr('data-color-scheme', 'scheme3');
            $header.removeClass('bg-scheme-background');
            $header.addClass('bg-scheme-background/0');
        }
        $megamenu.hide();
        $menuButton.find('.svg-scale').removeClass('rotate-180');
    }
}
// end: show megamenu on hover

// start: pdp media gallery
destroyDesktopPdpMediaSlider = () => {
    var $mediaGrid = $('.product-media .jsc-product-media-grid');
    if ($mediaGrid.length > 0 && $(window).width() > 820) {
        $mediaGrid.removeClass('splide');
    }
}

updateSliderProgress = () => {
    var $mediaSlider = $('.splide--product');
    if ($mediaSlider.length > 0) {
        var $progressBar = $mediaSlider.find('.jsc-splide-progress-bar');
        var slideCount = $mediaSlider.find('.feature-media-item').length;
        var $currentSlide = $mediaSlider.find('.feature-media-item.is-active');
        var index = parseInt($currentSlide.attr('data-index'));
        var progress = (index / slideCount) * 100;
        $progressBar.css('width', progress + '%');
        console.log('update progress', index);
    }
}
// end: pdp media gallery

// start: footer menu (mobile)
toggleAccordionMenu = (e) => {
    const accordionContent = $(e).closest('.jsc-menu-accordion-content');
    accordionContent.toggleClass('active');

    var otherMenuContent = accordionContent.parent('.jsc-menu-accordion-content-parent').siblings('.jsc-menu-accordion-content-parent');
    otherMenuContent.each(function(index, item) {
        var content = $(item).find('.jsc-menu-accordion-content');
        if(content.hasClass('active')) {
            content.removeClass('active');
        }
    });
}
// end: footer menu (mobile)

// start: sidebar menu toggle
toggleSubmenu = (evt) => {
    var index = $(evt).attr('data-index');
    var $submenu = $(`.jsc-sidebar-submenu[data-index="${index}"]`);
    var $arrow = $(evt).find('> div .theme-icon');

    if ($submenu.length > 0) {
        $submenu.toggleClass('active');
        $arrow.toggleClass('rotate-90');

        setTimeout(() => {
            var $submenuLink = $submenu.find('.jsc-submenu-link[aria-expanded="false"]');
            $submenuLink.click();
        }, 500);
    }
}
jscPostOpenLeftDrawer = () => {
    // To expand Shop submenu by default
    setTimeout(function() {
        $('#modals-leftDrawer button[aria-expanded="false"]').filter(function() {
            return $(this).find('span').text().trim() === 'Shop';
        }).click();
    }, 200);
}
// end: sidebar menu toggle

// start: complementary product slider
initSlider = ($slider, options) => {
    $($slider).flickity(options);
}

initComplementarySlider = () => {
    var intervalId = setInterval(() => {
        var $relatedProduct = $('.product-block-complementary .related-products ul');
        if ($relatedProduct.length > 0) {
            var options = {
                draggable: true,
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                prevNextButtons: true,
                wrapAround: false,
                cellAlign: 'left'
            }
            initSlider($relatedProduct, options);
            clearInterval(intervalId)
        }
    }, 100);
}
// end: complementary product slider

// start cartJS
cartJSBulkAdd = (items) => {
    CartJS.addItems(items,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
            console.log('success');
            $(document).on('cart.requestComplete', function(event, cart) {
                document.dispatchEvent(new CustomEvent('theme:update:cart')); // update cart
                Alpine.store('modals').open('cart'); // open cart drawer
                var itemCount = cart.item_count;
                var $cartBtn = $('#CartButton');
                $cartBtn.find('.jsc-cart-count').text(itemCount);
                $cartBtn.find('.jsc-cart-count').css('display, flex');
                performRecommendations();
            });
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", textStatus, errorThrown, jqXHR);

        }
    });
}

cartJSUpdateQuantity = (items) => {
    CartJS.updateItemQuantitiesById(items, {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
            console.log('success');
            $(document).on('cart.requestComplete', function(event, cart) {
                document.dispatchEvent(new CustomEvent('theme:update:cart')); // update cart
                Alpine.store('modals').open('cart'); // open cart drawer
                var itemCount = cart.item_count;
                var $cartBtn = $('#CartButton');
                $cartBtn.find('.jsc-cart-count').text(itemCount);
                $cartBtn.find('.jsc-cart-count').css('display, flex');
                performRecommendations();
            });
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", textStatus);

        }
    });
}

cartJSAdd = (vid, qty, obj) => {
    CartJS.addItem(vid, qty, obj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
            console.log('success');
            $(document).on('cart.requestComplete', function(event, cart) {
                document.dispatchEvent(new CustomEvent('theme:update:cart')); // update cart
                Alpine.store('modals').open('cart'); // open cart drawer
                var itemCount = cart.item_count;
                var $cartBtn = $('#CartButton');
                $cartBtn.find('.jsc-cart-count').text(itemCount);
                $cartBtn.find('.jsc-cart-count').css('display, flex');
                performRecommendations();
            });
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", textStatus);

        }
    });
}
// end cartJS

// start: cart GWP checkout sync
var cartCheckoutLocked = false;
var cartRequestInFlight = 0;
var nativeCartMutationInFlight = 0;
var cartGwpSyncInitialized = false;

hasPendingGwpActions = () => {
  return document.querySelectorAll('.jsc-add-gift, .jsc-remove-gift, .jsc-update-gift').length > 0;
};

isCartCheckoutBlocked = () => {
  return cartCheckoutLocked
    || cartRequestInFlight > 0
    || nativeCartMutationInFlight > 0
    || hasPendingGwpActions();
};

updateCheckoutButtonState = () => {
  var blocked = isCartCheckoutBlocked();
  $('.jsc-checkout-btn').prop('disabled', blocked);
  $('.jsc-checkout-btn').toggleClass('jsc-checkout-btn--disabled', blocked);
  document.querySelectorAll('.additional-checkout-buttons').forEach(function(el) {
    el.style.pointerEvents = blocked ? 'none' : '';
    el.style.opacity = blocked ? '0.5' : '';
  });
};

validateTierGwpDuplicates = (cart) => {
  if (!cart || !Array.isArray(cart.items)) {
    return false;
  }

  var tierTypes = ['Free Gift 1', 'Free Gift 2', 'Free Gift 3'];
  var removeList = {};

  tierTypes.forEach(function(tierType) {
    var tierItems = cart.items.filter(function(item) {
      return item.properties && item.properties['_Cart_Tier_GWP'] === tierType;
    });

    if (tierItems.length > 1) {
      for (var i = 0; i < tierItems.length - 1; i++) {
        removeList[tierItems[i].key] = 0;
      }
    }
  });

  if (Object.keys(removeList).length === 0) {
    return false;
  }

  cartJSUpdateQuantity(removeList);
  return true;
};

processGwpActions = () => {
  updateCheckoutButtonState();
  if (!hasPendingGwpActions()) {
    return;
  }

  removeGift();
  updateGift();
  addGift();
  updateCheckoutButtonState();
};

initCartGwpCheckoutSync = () => {
  if (cartGwpSyncInitialized) {
    return;
  }
  cartGwpSyncInitialized = true;

  document.addEventListener('shapes:cart:lock', function() {
    cartCheckoutLocked = true;
    updateCheckoutButtonState();
  });

  document.addEventListener('shapes:cart:unlock', function() {
    cartCheckoutLocked = false;
    requestAnimationFrame(function() {
      processGwpActions();
      updateCheckoutButtonState();
    });
  });

  $(document).on('cart.requestStarted', function() {
    cartRequestInFlight++;
    updateCheckoutButtonState();
  });

  $(document).on('cart.requestComplete', function(event, cart) {
    cartRequestInFlight = Math.max(0, cartRequestInFlight - 1);
    updateCheckoutButtonState();
    if (cart && typeof validateTierGwpDuplicates === 'function') {
      validateTierGwpDuplicates(cart);
    }
  });

  document.addEventListener('change', function(e) {
    if (e.target.matches('[data-cart-items] input[name="updates[]"]')) {
      nativeCartMutationInFlight++;
      updateCheckoutButtonState();
    }
  }, true);

  document.addEventListener('theme:line-item:error', function() {
    nativeCartMutationInFlight = Math.max(0, nativeCartMutationInFlight - 1);
    updateCheckoutButtonState();
  });

  document.addEventListener('theme:cart:error:other', function() {
    nativeCartMutationInFlight = Math.max(0, nativeCartMutationInFlight - 1);
    updateCheckoutButtonState();
  });

  document.addEventListener('theme:cart:change', function() {
    nativeCartMutationInFlight = Math.max(0, nativeCartMutationInFlight - 1);
    updateCheckoutButtonState();
    requestAnimationFrame(function() {
      processGwpActions();
    });
  });

  requestAnimationFrame(function() {
    processGwpActions();
  });
};
// end: cart GWP checkout sync

// start: bundle dummy helper
var checkoutInterceptorInProgress = false;

getCartJSON = async () => {
  var response = await fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch cart');
  }

  return response.json();
}

removeBundleDummy = async () => {
  var cart = await getCartJSON();
  var bundleSkuPrefix = 'BUNDLES/';
  var updates = {};

  if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
    return;
  }

  cart.items.forEach(function(item) {
    var sku = item && item.sku ? item.sku : '';
    if (sku.indexOf(bundleSkuPrefix) === 0 && item.key) {
      updates[item.key] = 0;
    }
  });

  if (Object.keys(updates).length === 0) {
    return;
  }

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      updates: updates
    })
  });
}

interceptCheckoutAndRemoveBundleSkuItems = async (evt) => {
  evt.preventDefault();

  if (checkoutInterceptorInProgress) {
    return false;
  }

  if (isCartCheckoutBlocked()) {
    return false;
  }

  checkoutInterceptorInProgress = true;
  $('.jsc-checkout-btn').attr('disabled', true);

  try {
    await removeBundleDummy();
  } catch (error) {
    console.log('Error while removing BUNDLES/ items before checkout.', error);
  }

  window.location.href = '/checkout';
  return false;
}

bindCheckoutInterceptor = () => {
  $(document).on('click', '.jsc-checkout-btn', function(evt) {
    interceptCheckoutAndRemoveBundleSkuItems(evt);
  });

  $(document).on('submit', 'form#cart', function(evt) {
    var nativeEvent = evt.originalEvent;
    var submitter = nativeEvent && nativeEvent.submitter ? nativeEvent.submitter : null;
    if (submitter && submitter.name === 'checkout') {
      interceptCheckoutAndRemoveBundleSkuItems(evt);
    }
  });
}
// end: bundle dummy helper

// start: product bundle
bindBundleMeasurementsModal = () => {
  mountBundleMeasurementsModalToBody();

  $(document).on('keydown.jscBundleMeasurementsModal', function (event) {
    if (event.key === 'Escape' && $('.jsc-bundle-measurements-modal.is-open').length) {
      closeBundleMeasurementsModal();
    }
  });
}

mountBundleMeasurementsModalToBody = () => {
  var $modal = $('.jsc-bundle-measurements-modal');
  if (!$modal.length || $modal.parent().is('body')) return;

  $modal.appendTo('body');
}

getBundleActiveProductId = ($grid) => {
  var $activeSwatch = $grid.find('.jsc-product-bundle__sibling-swatch.active');
  if (!$activeSwatch.length) return null;

  try {
    var productJson = JSON.parse($activeSwatch.attr('product-json'));
    return productJson && productJson.id ? productJson.id : null;
  } catch (e) {
    return null;
  }
}

updateBundleMeasurementsLink = ($grid, productJson) => {
  var $bundleGrid = $($grid);
  var $link = $bundleGrid.find('.jsc-product-bundle__measurements');
  if (!$link.length) return;

  var productId = productJson && productJson.id ? productJson.id : getBundleActiveProductId($bundleGrid);
  if (!productId) {
    $link.addClass('hidden');
    return;
  }

  var hasMeasurements = $bundleGrid
    .find('.jsc-product-bundle__measurements-template[data-product-id="' + productId + '"]')
    .length > 0;

  if (hasMeasurements) {
    $link.removeClass('hidden');
  } else {
    $link.addClass('hidden');
  }
}

openBundleMeasurementsModal = (event, el) => {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  var $grid = $(el).closest('.jsc-product-bundle__grid');
  var productId = getBundleActiveProductId($grid);
  if (!productId) return;

  var $template = $grid.find(
    '.jsc-product-bundle__measurements-template[data-product-id="' + productId + '"]'
  );
  if (!$template.length) return;

  mountBundleMeasurementsModalToBody();

  var $modal = $('.jsc-bundle-measurements-modal');
  var $body = $modal.find('.jsc-bundle-measurements-modal__body');
  $body.html($template.html());
  $modal.addClass('is-open').attr('aria-hidden', 'false');
  $('body').addClass('jsc-bundle-measurements-modal-open');
}

closeBundleMeasurementsModal = () => {
  var $modal = $('.jsc-bundle-measurements-modal');
  $modal.removeClass('is-open').attr('aria-hidden', 'true');
  $modal.find('.jsc-bundle-measurements-modal__body').empty();
  $('body').removeClass('jsc-bundle-measurements-modal-open');
}

selectBundleOptionsGrid = (evt) => {
  var $grid = $(evt);
  var $gridWrap = $grid.parents('.jsc-product-bundle__wrap');
  $grid.addClass('active');
  $gridWrap.siblings('.jsc-product-bundle__wrap').find('.jsc-product-bundle__options-grid').removeClass('active');

  recalculateAllBundlesPrice();
}

formatBundleMoney = (cents) => {
  var priceCents = parseInt(cents, 10) || 0;
  if (typeof formatMoney === 'function' && window.theme && theme.moneyFormat) {
    return ensureMoneyWrapper(formatMoney(priceCents, theme.moneyFormat));
  }
  return ensureMoneyWrapper((priceCents / 100).toFixed(2));
}

ensureMoneyWrapper = (formatted) => {
  if (formatted == null) return formatted;
  var str = String(formatted);
  if (/class=(["'])money\1/.test(str)) return str;
  if (str.indexOf('<') !== -1) return str;
  return '<span class="money">' + str + '</span>';
}

triggerBucksReConvert = () => {
  var runReConvert = function () {
    if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') {
      window.bucksCC.reConvert();
      return true;
    }
    return false;
  };

  clearTimeout(window.__jscBucksReConvertTimer);
  window.__jscBucksReConvertTimer = setTimeout(function () {
    if (!runReConvert()) {
      setTimeout(runReConvert, 500);
    }
  }, 50);
}

setBundlePriceEl = ($el, formatted) => {
  if (!$el || !$el.length || formatted == null) return;
  if (formatted === '') {
    $el.empty();
    return;
  }
  var output = ensureMoneyWrapper(formatted);
  if (String(output).indexOf('<') !== -1) {
    $el.html(output);
  } else {
    $el.text(output);
  }
}

getBundlePickerVariants = ($variantPicker, productJson) => {
  if ($variantPicker.length) {
    var $variantsData = $variantPicker.find('script.jsc-product-bundle__variants-data');
    if ($variantsData.length) {
      try {
        var parsed = JSON.parse($variantsData.text().trim());
        if (parsed && parsed.length) return parsed;
      } catch (e) {}
    }
  }
  return (productJson && productJson.variants) ? productJson.variants : [];
}

getBundleGridSelectedVariant = (productJson, $variantPicker) => {
  var variants = getBundlePickerVariants($variantPicker, productJson);
  if (!variants.length) return null;

  if (!$variantPicker.length) {
    return variants.find(function (v) { return v.available; }) || variants[0];
  }

  var selectedOptions = [];
  $variantPicker.find('.jsc-product-bundle__variant-option').each(function () {
    var $option = $(this);
    var position = parseInt($option.attr('option-index'), 10);
    var $activeValue = $option.find('.jsc-product-bundle__variant-value.active');
    if (!position || !$activeValue.length) return;

    var value = $activeValue.attr('data-option-value');
    if (value == null || value === '') return;

    selectedOptions.push({ position: position, value: String(value).trim() });
  });

  if (!selectedOptions.length) {
    return variants.find(function (v) { return v.available; }) || variants[0];
  }

  if (selectedOptions.length === 1) {
    var singleVariantId = $variantPicker
      .find('.jsc-product-bundle__variant-value.active')
      .attr('data-variant-id');
    if (singleVariantId) {
      var byId = variants.find(function (v) {
        return String(v.id) === String(singleVariantId);
      });
      if (byId) return byId;
    }
  }

  var matched = variants.find(function (variant) {
    return selectedOptions.every(function (opt) {
      var variantValue = variant['option' + opt.position];
      return variantValue != null && String(variantValue).trim() === opt.value;
    });
  });

  return matched || variants.find(function (v) { return v.available; }) || variants[0];
}

syncBundleSwatchToHandle = ($grid, productHandle) => {
  if (!productHandle) return;
  var $matchedSwatch = null;
  $grid.find('.jsc-product-bundle__sibling-swatch').each(function () {
    try {
      var swatchProduct = JSON.parse($(this).attr('product-json'));
      if (swatchProduct && swatchProduct.handle === productHandle) {
        $matchedSwatch = $(this);
        return false;
      }
    } catch (e) {}
  });
  if ($matchedSwatch && $matchedSwatch.length) {
    $grid.find('.jsc-product-bundle__sibling-swatch').removeClass('active');
    $matchedSwatch.addClass('active');
  }
}

getBundleVariantImageSrc = (variant, productJson) => {
  var featuredImage = variant && variant.featured_image;
  if (featuredImage) {
    if (typeof featuredImage === 'string') return featuredImage;
    if (featuredImage.src) return featuredImage.src;
  }
  featuredImage = productJson.featured_image;
  if (featuredImage) {
    if (typeof featuredImage === 'string') return featuredImage;
    if (featuredImage.src) return featuredImage.src;
  }
  return null;
}

updateBundleGridPrice = ($grid, selectedVariant) => {
  var $bundleGrid = $($grid);
  if (!selectedVariant || !$bundleGrid.length) return;

  var price = selectedVariant.price;
  var compareAtPrice = selectedVariant.compare_at_price;
  var priceCents = parseInt(price, 10) || 0;
  var compareCents = parseInt(compareAtPrice, 10) || 0;
  var onSale = compareCents > priceCents;
  var formattedPrice = formatBundleMoney(priceCents);
  var formattedCompare = compareCents ? formatBundleMoney(compareCents) : '';
  var $bundleGridPrice = $bundleGrid.find('.jsc-product-bundle__price');
  var $price = $bundleGridPrice.find('.price');

  $bundleGrid.attr('product-price', priceCents);
  $bundleGrid.attr('compare-price', compareCents);
  $bundleGrid.attr('data-variant-id', selectedVariant.id);

  if (onSale) {
    $price.addClass('price--on-sale');
    $price.find('.price__regular').addClass('hidden');
    $price.find('.price__sale').removeClass('hidden');
    setBundlePriceEl($price.find('.price-item--sale'), formattedPrice);
    setBundlePriceEl($price.find('.price__sale s.price-item--regular'), formattedCompare);
  } else {
    $price.removeClass('price--on-sale');
    $price.find('.price__regular').removeClass('hidden');
    $price.find('.price__sale').addClass('hidden');
    setBundlePriceEl($price.find('.price__regular .price-item--regular'), formattedPrice);
  }

  recalculateAllBundlesPrice();
}

selectBundleProduct = (evt) => {
  var $currentSwatch = $(evt);
  if ($currentSwatch.hasClass('is-unavailable')) return;
  var $otherSwatch = $currentSwatch.siblings('.jsc-product-bundle__sibling-swatch');
  var $bundleGrid = $currentSwatch.parents('.jsc-product-bundle__grid');

  $currentSwatch.addClass('active');
  $otherSwatch.removeClass('active');

  if ($bundleGrid.hasClass('jsc-product-bundle__options-grid')) {
    $bundleGrid.addClass('active');
    var $bundleWrap = $bundleGrid.parents('.jsc-product-bundle__wrap');
    $bundleWrap.siblings('.jsc-product-bundle__wrap').find('.jsc-product-bundle__options-grid').removeClass('active');
  }

  updateBundleProductInfo($bundleGrid);
}

selectBundleVariant = (event, el) => {
  if (event && event.stopPropagation) event.stopPropagation();

  var $value = $(el);
  if ($value.hasClass('not-available')) return;

  var $bundleVariantWrap = $value.parents('.jsc-product-bundle__variant-wrap');
  $bundleVariantWrap.find('.jsc-product-bundle__variant-value').removeClass('active');
  $value.addClass('active');

  var $picker = $value.closest('.jsc-product-bundle__variant-picker');
  var $grid = $value.closest('.jsc-product-bundle__grid');
  var productHandle = $picker.attr('product-handle');

  if ($grid.hasClass('jsc-product-bundle__options-grid')) {
    $grid.addClass('active');
    var $bundleWrap = $grid.parents('.jsc-product-bundle__wrap');
    $bundleWrap.siblings('.jsc-product-bundle__wrap').find('.jsc-product-bundle__options-grid').removeClass('active');
  }

  syncBundleSwatchToHandle($grid, productHandle);
  updateBundleProductInfo($grid, $picker);
}

updateBundleProductInfo = ($bundleGrid, $variantPickerOverride) => {
  var $grid = $($bundleGrid);
  var $variantPicker = ($variantPickerOverride && $variantPickerOverride.length)
    ? $($variantPickerOverride)
    : null;
  var $activeSwatch = $grid.find('.jsc-product-bundle__sibling-swatch.active');
  var productJson = {};

  if ($activeSwatch.length) {
    try {
      productJson = JSON.parse($activeSwatch.attr('product-json'));
    } catch (e) {
      productJson = {};
    }
  }

  if (!$variantPicker || !$variantPicker.length) {
    var productHandle = productJson.handle;
    if (!productHandle) return;
    $variantPicker = $grid.find('.jsc-product-bundle__variant-picker[product-handle="' + productHandle + '"]');
  }
  var $bundleGridImage = $grid.find('.jsc-product-bundle__image');
  var selectedVariant = getBundleGridSelectedVariant(productJson, $variantPicker);
  var imageSrc = getBundleVariantImageSrc(selectedVariant, productJson);

  if (imageSrc) {
    $bundleGridImage.find('img').attr('src', imageSrc);
    $bundleGridImage.find('img').attr('srcset', '');
  }

  $grid.find('.jsc-product-bundle__variant-picker').removeClass('active');
  $variantPicker.addClass('active');
  updateBundleGridPrice($grid, selectedVariant);
  updateBundleMeasurementsLink($grid, productJson);
}

getActiveCount = ($bundleWrap) => {
    var $activeGrids = $($bundleWrap).find('.jsc-product-bundle__grid.active');
    var limit = parseInt($($bundleWrap).attr('data-limit'));
    var activeCount = 0;

    if ($activeGrids.length > 0) {
        if (limit > 1) {
            $activeGrids.each(function() {
                var $qtySelector = $(this).find('.jsc-product-bundle__qty-selector.active');
                var qty = parseInt($qtySelector.find('.jsc-product-bundle__qty-input').val());
                activeCount += qty;
            });
        }
        else {
            activeCount = $activeGrids.length;
        }
    }

    return activeCount;
}

addBundle = (evt) => {
  var $currentGrid = $(evt).parents('.jsc-product-bundle__grid');
  var $bundleWrap = $(evt).parents('.jsc-product-bundle__wrap');
  var limit = parseInt($bundleWrap.attr('data-limit'));

  var wasActive = $currentGrid.hasClass('active');

  if (wasActive) { 
      $currentGrid.removeClass('active');
      $currentGrid.find('.jsc-product-bundle__button').text('Add');
  }
  else {
      var activeCount = getActiveCount($bundleWrap);

      if (activeCount < limit) {
          $currentGrid.addClass('active');
          if (limit > 1) {
              $currentGrid.find('.jsc-product-bundle__qty-selector').addClass('active');
              $currentGrid.find('.jsc-product-bundle__button').addClass('hide');
          }
          else {
              $currentGrid.find('.jsc-product-bundle__button').text('Added');
          }
      }
  }

  recalculateAllBundlesPrice();
  updateBundleButton();
}

recalculateAllBundlesPrice = () => {
  var $upsellBundle = $('.jsc-product-bundle.jsc-bundle-upsell');
  var $productBundle = $('.jsc-product-bundle').not('.jsc-bundle-upsell');
  var $bundleContainer = $productBundle.length ? $productBundle.first() : $upsellBundle.first();
  var $allBundles = $bundleContainer.find('.jsc-product-bundle__wrap');
  if (!$allBundles.length) return;

  var discountPercentage = parseInt($bundleContainer.attr('discount-percentage'), 10) || 0;
  var discountRate = discountPercentage / 100;
  var subtotalCents = 0;
  var compareSubtotalCents = 0;
  var activeGridCount = 0;
  var limitsMetCount = 0;
  var $mainWraps = $allBundles.filter(function () {
    return $(this).find('.jsc-product-bundle__options-grid').length === 0;
  });
  var $optionWraps = $allBundles.filter(function () {
    return $(this).find('.jsc-product-bundle__options-grid').length > 0;
  });
  var requiredCount = $mainWraps.length + ($optionWraps.length > 0 ? 1 : 0);

  $mainWraps.each(function () {
    var $bundleWrap = $(this);
    var limit = parseInt($bundleWrap.attr('data-limit'), 10) || 1;
    if (getActiveCount($bundleWrap) >= limit) {
      limitsMetCount++;
    }
  });

  if ($optionWraps.length > 0 && $optionWraps.find('.jsc-product-bundle__options-grid.active').length > 0) {
    limitsMetCount++;
  }

  $allBundles.each(function () {
    $(this).find('.jsc-product-bundle__grid.active').each(function () {
      var $grid = $(this);
      var priceCents = parseInt($grid.attr('product-price'), 10);
      if (isNaN(priceCents)) {
        var priceText = $grid.find('.jsc-product-bundle__price .price-item--sale, .jsc-product-bundle__price .price-item--regular').first().text();
        priceCents = Math.round((parseFloat(priceText.replace(/[^0-9.-]+/g, '')) || 0) * 100);
      }
      var compareCents = parseInt($grid.attr('compare-price'), 10) || 0;
      var qty = parseInt($grid.find('.jsc-product-bundle__qty-input').val(), 10) || 1;

      activeGridCount++;
      subtotalCents += priceCents * qty;
      compareSubtotalCents += (compareCents > priceCents ? compareCents : priceCents) * qty;
    });
  });

  if (activeGridCount === 0) {
    var $emptyBundlePriceDisplay = $('.jsc-bundle-price-display');
    $emptyBundlePriceDisplay.hide();
    $('.jsc-pdp-price').show();
    var $emptyStickyPrice = $('.sticky-add-to-cart').find('.jsc-sticky-bundle-price');
    if (!$emptyStickyPrice.length) {
      $emptyStickyPrice = $('.sticky-add-to-cart').find('.sticky-atc-price-wrap .sticky-atc-price').first();
    }
    if ($emptyStickyPrice.length) $emptyStickyPrice.empty();
    var $emptyPriceInput = $('.jsc-bundle-total-price');
    if ($emptyPriceInput.length) {
      $emptyPriceInput.val('0');
      $emptyPriceInput.attr('data-bundle-total-price', 0);
      $emptyPriceInput.attr('data-bundle-subtotal', 0);
    }
    triggerBucksReConvert();
    return;
  }

  if ($upsellBundle.length) {
    var mainPriceText = $('.jsc-pdp-price span[data-product-price]').text();
    var mainPriceCents = Math.round((parseFloat(mainPriceText.replace(/[^0-9.-]+/g, '')) || 0) * 100);
    var mainCompareText = $('.jsc-pdp-price s[data-compare-price]').text();
    var mainCompareCents = Math.round((parseFloat(mainCompareText.replace(/[^0-9.-]+/g, '')) || 0) * 100);
    subtotalCents += mainPriceCents;
    compareSubtotalCents += mainCompareCents > mainPriceCents ? mainCompareCents : mainPriceCents;
  }

  var isDiscountApplied = requiredCount > 0 && limitsMetCount === requiredCount && discountRate > 0;
  var finalCents = isDiscountApplied
    ? Math.round(subtotalCents * (1 - discountRate))
    : subtotalCents;
  var showCompareAtSubtotal = compareSubtotalCents > subtotalCents;
  var $defaultPriceBlock = $('.jsc-pdp-price');
  var $bundlePriceDisplay = $('.jsc-bundle-price-display');
  var $mainPrice = $bundlePriceDisplay.find('.jsc-bundle-main-price');
  var $comparePriceContainer = $bundlePriceDisplay.find('.jsc-bundle-compare-price-container');
  var $comparePriceElement = $comparePriceContainer.find('s');
  var $stickyBar = $('.sticky-add-to-cart');
  var $stickyPrice = $stickyBar.find('.jsc-sticky-bundle-price');
  if (!$stickyPrice.length) {
    $stickyPrice = $stickyBar.find('.sticky-atc-price-wrap .sticky-atc-price').first();
  }

  if (isDiscountApplied) {
    $defaultPriceBlock.hide();
    $bundlePriceDisplay.css('display', 'flex');
    setBundlePriceEl($mainPrice, formatBundleMoney(finalCents));
    $comparePriceContainer.show();
    setBundlePriceEl($comparePriceElement, formatBundleMoney(subtotalCents));
    setBundlePriceEl($stickyPrice, formatBundleMoney(finalCents));
  } else if (showCompareAtSubtotal) {
    $defaultPriceBlock.hide();
    $bundlePriceDisplay.css('display', 'flex');
    setBundlePriceEl($mainPrice, formatBundleMoney(subtotalCents));
    $comparePriceContainer.show();
    setBundlePriceEl($comparePriceElement, formatBundleMoney(compareSubtotalCents));
    setBundlePriceEl($stickyPrice, formatBundleMoney(subtotalCents));
  } else if (finalCents > 0) {
    $defaultPriceBlock.show();
    $bundlePriceDisplay.hide();
    setBundlePriceEl($defaultPriceBlock.find('span[data-product-price]'), formatBundleMoney(finalCents));
    $defaultPriceBlock.find('s[data-compare-price]').parent().hide();
    setBundlePriceEl($stickyPrice, formatBundleMoney(finalCents));
  } else {
    $defaultPriceBlock.hide();
    $bundlePriceDisplay.hide();
    if ($stickyPrice.length) $stickyPrice.empty();
  }

  $bundlePriceDisplay.attr('product-price', finalCents);
  $bundlePriceDisplay.attr(
    'compare-price',
    isDiscountApplied ? subtotalCents : compareSubtotalCents
  );

  var $priceInput = $('.jsc-bundle-total-price');
  if ($priceInput.length) {
    $priceInput.val((finalCents / 100).toFixed(2));
    $priceInput.attr('data-bundle-total-price', finalCents);
    $priceInput.attr('data-bundle-subtotal', subtotalCents);
  }

  triggerBucksReConvert();
}

updateBundleButton = () => {
    var $bundleWrap = $('.jsc-product-bundle .jsc-product-bundle__wrap');
    var $bundleAtc = $('.product-content .jsc-bundle-atc');
    var canAtc = true;
    
    if ($bundleWrap.length > 0) {
        $bundleWrap.each(function() {
            var limit = parseInt($(this).attr('data-limit'));
            var activeCount = getActiveCount($(this));
            var $inactiveGrids = $(this).find('.jsc-product-bundle__grid:not(.active)');

            if (activeCount >= limit) {
                $inactiveGrids.find('.jsc-product-bundle__button:not(.sold-out)').attr('disabled', '');
            }
            else {
                $inactiveGrids.find('.jsc-product-bundle__button:not(.sold-out)').removeAttr('disabled');
                canAtc = false;
            }
        });

        if (canAtc == true) {
            $bundleAtc.removeAttr('disabled');
        }
        else {
            $bundleAtc.attr('disabled', '');
        }
    }
}

minusQty = (evt) => {
    var $qtyInput = $(evt).siblings('.jsc-product-bundle__qty-input');
    var qty = parseInt($qtyInput.val());
    var newQty = qty - 1;
    var $qtySelector = $(evt).parent();
    var $gridButton = $qtySelector.siblings('.jsc-product-bundle__button');
    var $currentGrid = $(evt).parents('.jsc-product-bundle__grid');

    if (newQty <= 0) {
        $currentGrid.removeClass('active');
        $qtySelector.removeClass('active');
        $gridButton.removeClass('hide');
    }
    else {
        $qtyInput.val(newQty)
    }
    recalculateAllBundlesPrice();
    updateBundleButton();
}

addQty = (evt) => {
    var $bundleWrap = $(evt).parents('.jsc-product-bundle__wrap');
    var limit = parseInt($bundleWrap.attr('data-limit'));
    var activeCount = getActiveCount($bundleWrap);
    var newActiveCount = activeCount + 1;

    if (newActiveCount <= limit) {
        var $qtyInput = $(evt).siblings('.jsc-product-bundle__qty-input');
        var qty = parseInt($qtyInput.val());
        var newQty = qty + 1;
        $qtyInput.val(newQty);
    }
    recalculateAllBundlesPrice();
    updateBundleButton();
}

bundleATC = () => {
    var $activeGrids = $('.jsc-product-bundle .jsc-product-bundle__grid.active');
    if ($activeGrids.length > 0) {
        var items = [];
        var bundleSet = $('.jsc-product-bundle').attr('bundle-set');

        // main item
        var mainID = parseInt($('.product-content form[data-product-form] select[name="id"]').val());
        var seconds = new Date().getTime() / 1000;
        var bindID = mainID + '-' + seconds;
        var mainItem = {
            'id': mainID,
            'quantity': 1,
            'properties': {
                '_MainProduct': 'Yes',
                '_BindID': bindID
            }
        };
        items.push(mainItem);

        // bundle item
        $activeGrids.each(function() {
            var id = parseInt($(this).attr('data-variant-id'));
            var bundleItem = {
                'id': id,
                'quantity': 1,
                'properties': {
                    '_BindID': bindID,
                    '_BundleProduct': 'Yes',
                    '_BundleSet': bundleSet
                }
            };

            items.push(bundleItem);
        });

        cartJSBulkAdd(items);
    }
    else {
        var $appBundleBtn = $('.rbr-bap-new-footer');
        if ($appBundleBtn.length > 0) {
            $appBundleBtn.click();
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent('theme:update:cart')); // update cart
                Alpine.store('modals').open('cart'); // open cart drawer
                var itemCount = cart.item_count;
                var $cartBtn = $('#CartButton');
                $cartBtn.find('.jsc-cart-count').text(itemCount);
                $cartBtn.find('.jsc-cart-count').css('display, flex');
            }, 1000);
        }
    }
}

bundleUpsellATC = (template) => {
  var $bundleGrid = $('.jsc-product-bundle .jsc-product-bundle__grid');
  var $activeGrids = $('.jsc-product-bundle .jsc-product-bundle__grid.active');
  if ($bundleGrid.length > 0) {
      var bundleSet = $('.jsc-product-bundle.jsc-bundle-upsell').attr('bundle-set');
      var items = [];

      // main item
      var mainID = parseInt($('.product-content form[data-product-form] select[name="id"]').val());
      var seconds = new Date().getTime() / 1000;
      var bindID = mainID + '-' + seconds;
      var mainItem = {
          'id': mainID,
          'quantity': 1,
          'properties': {}
      };
      if ($activeGrids.length > 0) {
        mainItem.properties['_MainProduct'] = 'Yes';
        mainItem.properties['_BundleProduct'] = 'Yes';
        mainItem.properties['_BundleUpsellProduct'] = 'Yes';      
        mainItem.properties['_BindID'] = bindID;
        mainItem.properties['_BundleSet'] = bundleSet;
      }
      items.push(mainItem);

      // bundle item
      $activeGrids.each(function() {
          var id = parseInt($(this).attr('data-id'));
          var $qtyInput = $(this).find('.jsc-product-bundle__qty-input');
          var qty = parseInt($qtyInput.val());
          var bundleItem = {
              'id': id,
              'quantity': qty,
              'properties': {
                  '_BundleProduct': 'Yes',
                  '_BundleUpsellProduct': 'Yes',
                  '_BundleSet': bundleSet,
                  '_BindID': bindID
              }
          };

          items.push(bundleItem);
      });

      cartJSBulkAdd(items);
  }
  else {
      var $appBundleBtn = $('.rbr-bap-new-footer');
      if ($appBundleBtn.length > 0) {
          $appBundleBtn.click();
          setTimeout(() => {
              document.dispatchEvent(new CustomEvent('theme:update:cart')); // update cart
              Alpine.store('modals').open('cart'); // open cart drawer
              var itemCount = cart.item_count;
              var $cartBtn = $('#CartButton');
              $cartBtn.find('.jsc-cart-count').text(itemCount);
              $cartBtn.find('.jsc-cart-count').css('display, flex');
          }, 1000);
      }

    // #15605 if the Bundle Upsell is hidden, the template will allow add-to-cart of the main item
    var mainID = parseInt($('.product-content form[data-product-form] select[name="id"]').val());
    //console.log('add-to-cart from bundleATC',mainID);
    cartJSAdd(mainID, 1, {});
  }
}

removeCartItemsByBindId = (bindId) => {
  if (!bindId) {
      return;
  }
  var removeList = {};
  $('.jsc-cart-item').each(function() {
      if ($(this).attr('data-bind-id') === bindId) {
          var itemKey = $(this).attr('data-line-item-key');
          if (itemKey) {
              removeList[itemKey] = 0;
          }
      }
  });
  if (Object.keys(removeList).length === 0) {
      return;
  }
  cartJSUpdateQuantity(removeList);
}

removeBundle = (evt) => {
  var $cartItem = $(evt).parents('.jsc-cart-item');
  removeCartItemsByBindId($cartItem.attr('data-bind-id'));
}

checkIncompleteBundle = () => {
    var $cartItems = $('.jsc-cart-item');
    var removeList = {};

    $cartItems.each(function() {
        var available = $(this).attr('data-available');
        if (available == false) {
            var bindID = $(this).attr('data-bind-id');
            
            if (bindID != '') {
                var $bundleItems = $(`.jsc-cart-item[data-bind-id="${bindID}"]`);
                $bundleItems.each(function(index, $item) {
                    var itemKey = $($item).attr('data-line-item-key');
                    removeList[itemKey] = 0;
                });
            }
        }
    });

    if (Object.keys(removeList).length > 0) {
        $('.alert_popup_modal').show();
        cartJSUpdateQuantity(removeList);
    }
}

closeAlertPopup = () =>{
    $('.alert_popup_modal').hide();
}

updatePdpBundlePrice = () => {
    var $pdpPrice = $('.jsc-pdp-price[is-bundle-price]');
    if ($pdpPrice.length > 0) {
        var bundlePriceCents = Math.round(parseFloat($pdpPrice.attr('bundle-price')) * 100) || 0;
        var bundleComparePriceCents = Math.round(parseFloat($pdpPrice.attr('bundle-compare-price')) * 100) || 0;

        setBundlePriceEl($pdpPrice.find('.jsc-product-price'), formatBundleMoney(bundlePriceCents));
        setBundlePriceEl($pdpPrice.find('.jsc-product-compare-price'), formatBundleMoney(bundleComparePriceCents));
        triggerBucksReConvert();
    }
}

updateBundleSliderHeight = () => {
    var $bundleSlider = $('.jsc-product-bundle .jsc-product-bundle__slider');
    if ($bundleSlider.length > 0) {
        $bundleSlider.each(function() {
            var maxTitleHeight = 0;
            var maxSubtitleHeight = 0;
            var maxVariantHeight = 0;
            var $grid = $(this).find('.jsc-product-bundle__grid');

            $grid.each(function() {
                var $title = $(this).find('.jsc-product-bundle__title');
                var $subtitle = $(this).find('.jsc-product-bundle__color');
                var $variant = $(this).find('.jsc-product-bundle__variant_title');
                var titleHeight = $title.outerHeight();
                var subtitleHeight = $subtitle.outerHeight();
                var variantHeight = $variant.outerHeight();
                
                if (titleHeight > maxTitleHeight) {
                    maxTitleHeight = titleHeight;
                }

                if (subtitleHeight > maxSubtitleHeight) {
                    maxSubtitleHeight = subtitleHeight;
                }

                if (variantHeight > maxVariantHeight) {
                  maxVariantHeight = variantHeight;
                }
            });

            $grid.find('.jsc-product-bundle__title').css('height', maxTitleHeight + 'px');
            $grid.find('.jsc-product-bundle__color').css('height', maxSubtitleHeight + 'px');
            $grid.find('.jsc-product-bundle__variant_title').css('height', maxVariantHeight + 'px');
        });
    }
}
// end: product bundle

updateAppBundleButton = () => {
    setInterval(() => {
        var $appBundleBtn = $('.rbr-bap-new-footer');
        var $bundleAtc = $('.jsc-app-bundle-atc');
        if ($appBundleBtn.children('span').length > 0) {
            $bundleAtc.attr('disabled', '');
        }
        else {
            $bundleAtc.removeAttr('disabled');
        }
    }, 500);
}

toggleCountrySelector = (evt) => {
    var $countrySelector = $(evt).siblings('[country-selector]');
    var $toggleIcon = $(evt).find('[toggle-icon]');
    var isOpen = $countrySelector.attr('open');

    if (isOpen) {
        $countrySelector.removeAttr('open');
        $toggleIcon.removeAttr('open');
    }
    else {
        $countrySelector.attr('open', '');
        $toggleIcon.attr('open', '');
    }
}

// start: collection list
initCollectionListSplide = () => {
    const sliders = document.querySelectorAll('.jsc-collection-list-splide');

    sliders.forEach((slider) => {
        new Splide(slider, {
        type: 'slide',
        gap: '1.5rem',
        arrows: false,
        pagination: false,
        autoWidth: true
        }).mount();
    });
}
// end: collection list

// start: cart recommendations
performRecommendations = () => {
    setTimeout(() => {
        var recommendations = $('.jsc-cart-recommendations');
        if (recommendations.length > 0) {
            var url = recommendations.attr('data-url');
            fetch(url)
                .then(response => response.text())
                .then(text => {
                    var recommendationsHMTL = new DOMParser()
                        .parseFromString(text, 'text/html')
                        .querySelector('[data-recommendations]').innerHTML;
                    
                    recommendations.html(recommendationsHMTL);
                    initRecommendationsSplide();
                });
        }
    }, 1000);   
}

initRecommendationsSplide = () => {
    const sliders = document.querySelectorAll('.jsc-cart-recommendations-splide');

    sliders.forEach((slider) => {
        if (slider.dataset.splideCartRecInitialized === 'true') return;

        const splide = new Splide(slider, {
            type: 'slide',
            gap: '1.5rem',
            arrows: false,
            pagination: false
        });

        splide.mount();
        slider.dataset.splideCartRecInitialized = 'true';

        const root = slider.closest('.jsc-cart-recommendations');
        const prevBtn = root && root.querySelector('.jsc-cart-recommendations__arrow--prev');
        const nextBtn = root && root.querySelector('.jsc-cart-recommendations__arrow--next');

        if (!prevBtn || !nextBtn) return;

        const getEnd = () => {
            try {
                return splide.Components.Controller.getEnd();
            } catch (e) {
                return Math.max(0, splide.length - 1);
            }
        };

        const updateArrows = () => {
            const end = getEnd();
            const index = splide.index;
            prevBtn.disabled = index <= 0;
            nextBtn.disabled = index >= end;
        };

        prevBtn.addEventListener('click', () => splide.go('<'));
        nextBtn.addEventListener('click', () => splide.go('>'));
        splide.on('mounted moved resized updated', updateArrows);
        updateArrows();
    });
}

cartRecommendationATC = (evt) => {
    var $form = $(evt).parents('.quick-buy-product-form');
    var id = parseInt($form.find('input[name="id"]').val());
    cartJSAdd(id, 1, {});
}
// end: cart recommendations

initSizeGuideSplide = () => {
  const sliders = document.querySelectorAll('.jsc-size-guide-wrap');

  sliders.forEach((slider) => {
      // Skip if already initialized or if slider is hidden
      if (slider.classList.contains('is-initialized')) return;
      if (!slider.offsetParent && slider.style.display !== 'none') {
        // Element is hidden (likely in a hidden tab), skip initialization
        var parentPanel = slider.closest('[role="tabpanel"]');
        if (parentPanel && parentPanel.style.display === 'none') return;
      }

      var maxHeight = 0;
      var $grid = $(slider).find('.splide__slide .jsc-size-guide-grid');
      $grid.each(function(index, $g) {
        var height = $($g).outerHeight(true);
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      if (maxHeight > 0) {
        $grid.css('height', maxHeight + 'px');
      }

      new Splide(slider, {
      type: 'slide',
      autoWidth: true,
      gap: '15px',
      arrows: false,
      pagination: false
      }).mount();
  });
}

var masterPromoInitialized = false;

masterPromo = () => {
  if (!masterPromoInitialized) {
    masterPromoInitialized = true;
    $(document).on('cart.requestStarted', function() {
      $('.jsc-page-loading').show();
    });
    $(document).on('cart.requestComplete', function(event, cart) {
      $('.jsc-page-loading').hide();
      document.dispatchEvent(new CustomEvent('theme:update:cart'));
      Alpine.store('modals').open('cart');
      var itemCount = cart.item_count;
      var $cartBtn = $('#CartButton');
      $cartBtn.find('.jsc-cart-count').text(itemCount);
      $cartBtn.find('.jsc-cart-count').css('display', 'flex');
      performRecommendations();
    });
  }
  processGwpActions();
};
  
  cartJSAddQuery = (vid, qty, prop) => {
  // Cart js add item, success callback, error callback
  
  CartJS.addItem(vid, qty, prop,
    {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        console.log('Added item to cart');
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
      }
    });
  }
  
  addGift = () =>{
      console.log("here", $('.jsc-add-gift').length);
      if ($('.jsc-add-gift').length > 0) {
          $('.jsc-add-gift').each(function() {
              console.log("here");
              const varID = $(this).val();
              const varQty = parseInt($(this).attr('data-quantity')) || 1;
  
              let properties = $(this).attr('data-properties');
              let propsObj = {};
              if (properties) {
                  try {
                  propsObj = JSON.parse(properties);
                  } catch (e) {
                  console.warn('Invalid data-properties JSON', e);
                  }
              }
  
              // ✅ Add gift to cart
              cartJSAddQuery(varID, varQty, propsObj);
          });
      }
  }
  removeGift = () =>{
    if ($('.jsc-remove-gift').length > 0) {
      var jsonObj = {};
      $('.jsc-remove-gift').each(function(){
        var varID = $(this).val();
        jsonObj[varID] = 0;
      });
      CartJS.updateItemQuantitiesById(jsonObj);
    }
  }
  updateGift = () =>{
    if ($('.jsc-update-gift').length > 0) {
      $('.jsc-update-gift').each(function(){
        var varID = $(this).val();
        var QTY = parseInt($(this).attr('data-quantity'));
        CartJS.updateItemById(varID, QTY);
      });
    }
  }
  removeGWPItem = (itemKey) =>{
	CartJS.updateItemById(itemKey, 0);
}

initSizeGuideSplide = () => {
    const sliders = document.querySelectorAll('.jsc-size-guide-wrap');

    sliders.forEach((slider) => {
      var maxHeight = 0;
        var $grid = $(slider).find('.splide__slide .jsc-size-guide-grid');
        $grid.each(function(index, $g) {
          var height = $($g).outerHeight(true);
          if (height > maxHeight) {
            maxHeight = height;
          }
        });

        $grid.css('height', maxHeight + 'px');

        new Splide(slider, {
        type: 'slide',
        autoWidth: true,
        gap: '15px',
        arrows: false,
        pagination: false
        }).mount();
    });
}

showRewardPopup = () => {
  window.SmileUI.openPanel();
}

// start: charm set bundle
var selectedCharms = [];
updateCharmSetContent = (evt) => {
  var index = $(evt).attr('index');
  var $otherCharmMenu = $(evt).siblings('.jsc-charm-set-bundle__menu-item');
  var $currentContent = $(evt).parents('.jsc-charm-set-bundle').find(`[jsc-bundle-content][index="${index}"]`);
  var $otherContent = $(evt).parents('.jsc-charm-set-bundle').find(`[jsc-bundle-content]`);

  $otherCharmMenu.removeAttr('active');
  $(evt).attr('active', '');
  $otherContent.removeAttr('active');
  $currentContent.attr('active', '');
}

updateCharmLimit = () => {
  var $activeChain = $('.jsc-charm-set-bundle .jsc-charm-set-bundle__grid[chain-grid][active]:first');
  if ($activeChain.length > 0) {
    var minCharm = parseInt($activeChain.attr('charm-min'));
    var maxCharm = parseInt($activeChain.attr('charm-max'));

    var chainContentIndex = parseInt($activeChain.parents('.jsc-charm-set-bundle__content-wrap').attr('index'));
    var charmContentIndex = chainContentIndex + 1;
    var $charmContent = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${charmContentIndex}"]`);
    if ($charmContent.length > 0) {
      $charmContent.each(function() {
        $(this).attr('item-limit-min', minCharm);
        $(this).attr('item-limit-max', maxCharm);

        var $charmContentTitle = $(this).find('.jsc-charm-set-bundle__content-title');
        if (minCharm == maxCharm) {
          $charmContentTitle.text(`Select a minimum of ${maxCharm} charms`);
        }
        else {
          $charmContentTitle.text(`Select a minimum of ${minCharm} charms, maximum ${maxCharm}`);
        }

        var index = $(this).attr('index');
        var $charmMenu = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__menu-item[index="${index}"]`);
        $charmMenu.find('.jsc-charm-bundle-set__charm-max-number').text(maxCharm);

        var $charmGrid = $(this).find('.jsc-charm-set-bundle__grid');
        $charmGrid.each(function() {
          $(this).find('.jsc-charm-set-bundle__qty-input').attr('max', maxCharm);
        });
      });
    }
  }
}

getCharmSetActiveCount = ($contentWrap) => {
  var $activeGrids = $($contentWrap).find('.jsc-charm-set-bundle__grid[active]');
  var limit = parseInt($($contentWrap).attr('item-limit-max'));
  var activeCount = 0;

  if ($activeGrids.length > 0) {
    if (limit > 1) {
      $activeGrids.each(function() {
        var $qtySelector = $(this).find('.jsc-charm-set-bundle__qty-selector');
        var qty = parseInt($qtySelector.find('.jsc-charm-set-bundle__qty-input').val());
        activeCount += qty;
      });
    }
    else {
      activeCount = $activeGrids.length;
    }
  }
  return activeCount;
}

updateSelectedCharmCount = ($contentWrap) => {
  var activeCount = getCharmSetActiveCount($contentWrap);
  var index = $contentWrap.attr('index');
  var $charmMenu = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__menu-item[index="${index}"]`);
  $charmMenu.find('.jsc-charm-bundle-set__charm-selected-number').text(activeCount);
}

addCharms = ($grid) => {
  var id = $($grid).attr('data-id');
  var overlay = $($grid).attr('data-overlay');
  var index = selectedCharms.length;

  selectedCharms.push({
    'index': index,
    'id': id,
    'overlay': overlay
  });
}

removeCharms = ($grid, isRemoveAll) => {
  var id = $($grid).attr('data-id');

  if (isRemoveAll) {
    selectedCharms = selectedCharms.filter(charm => charm.id != id);
  } else {
    var lastIndex = selectedCharms.findLastIndex(charm => charm.id == id);
    if (lastIndex != -1) {
      selectedCharms.splice(lastIndex, 1);
    }
  }
}

updateCharmSetSelect = (evt) => {
  var $contentWrap = $(evt).parents('.jsc-charm-set-bundle__content-wrap');
  var index = parseInt($contentWrap.attr('index'));
  var $currentContentWrap = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${index}"]`);
  var gridId = $(evt).attr('data-id');
  var limitMin = parseInt($contentWrap.attr('item-limit-min'));
  var limitMax = parseInt($contentWrap.attr('item-limit-max'));

  if (limitMax == 1) {
    if ($(evt).attr('active') == undefined) {
      var charmContentIndex = index + 1;
      var $charmContent = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${charmContentIndex}"]`);
      var $charmGrid = $charmContent.find('.jsc-charm-set-bundle__grid');
      $charmGrid.each(function() {
        $(this).removeAttr('active');
        $(this).find('.jsc-charm-set-bundle__qty-input').val('0');
      });

      $charmContent.each(function() {
        updateSelectedCharmCount($(this));
      });
      selectedCharms = [];
    }

    $currentContentWrap.each(function() {
      var $currentGrid = $(this).find(`.jsc-charm-set-bundle__grid[data-id="${gridId}"]`);
      var $otherGrid = $(this).find('.jsc-charm-set-bundle__grid');
      $otherGrid.removeAttr('active');
      $currentGrid.attr('active', '');
    });
    updateCharmLimit();
  }
  else if (limitMax > 1) {
    var $charmContent = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${index}"]`);
    if ($(evt).attr('active') == undefined) {
      var activeCount = getCharmSetActiveCount($contentWrap);
      if (activeCount < limitMax) {
        $charmContent.each(function() {
          var $currentGrid = $(this).find(`.jsc-charm-set-bundle__grid[data-id="${gridId}"]`);
          $currentGrid.attr('active', '');
          $currentGrid.find('.jsc-charm-set-bundle__qty-input').val('1');
          updateSelectedCharmCount($(this));
        });
        addCharms($(evt));
      }
    }
    else {
      $charmContent.each(function() {
        var $currentGrid = $(this).find(`.jsc-charm-set-bundle__grid[data-id="${gridId}"]`);
        $currentGrid.removeAttr('active');
        $currentGrid.find('.jsc-charm-set-bundle__qty-input').val('0');
        updateSelectedCharmCount($(this));
      });
      removeCharms($(evt), true);
    }
  }

  updateCharmSetBundleButton();
  calculateCharmSetBundlePrice();
  updateCharmOverlayImage();
}

charmSetMinusQty = (event, evt) => {
  event.stopPropagation();

  var $qtyInput = $(evt).siblings('.jsc-charm-set-bundle__qty-input');
  var qty = parseInt($qtyInput.val());
  var newQty = qty - 1;
  var $currentGrid = $(evt).parents('.jsc-charm-set-bundle__grid');
  var gridId = $currentGrid.attr('data-id');
  var $contentWrap = $(evt).parents('.jsc-charm-set-bundle__content-wrap');
  var contentWrapIndex = $contentWrap.attr('index');
  var $grid = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${contentWrapIndex}"] .jsc-charm-set-bundle__grid[data-id="${gridId}"]`);

  if (newQty <= 0) {
    $grid.removeAttr('active');
    newQty = 0;
  }

  $grid.find('.jsc-charm-set-bundle__qty-input').val(newQty);

  var $content = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${contentWrapIndex}"]`);
  $content.each(function() {
    updateSelectedCharmCount($(this));
  });
  removeCharms($currentGrid, false);
  updateCharmSetBundleButton();
  calculateCharmSetBundlePrice();
  updateCharmOverlayImage();
}

charmSetAddQty = (event, evt) => {
  event.stopPropagation();
  
  var $contentWrap = $(evt).parents('.jsc-charm-set-bundle__content-wrap');
  var contentWrapIndex = $contentWrap.attr('index');
  var $currentGrid = $(evt).parents('.jsc-charm-set-bundle__grid');
  var gridId = $currentGrid.attr('data-id');
  var limit = parseInt($contentWrap.attr('item-limit-max'));
  var activeCount = getCharmSetActiveCount($contentWrap);
  var newActiveCount = activeCount + 1;
  var $grid = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${contentWrapIndex}"] .jsc-charm-set-bundle__grid[data-id="${gridId}"]`);

  if (newActiveCount <= limit) {
    var $qtyInput = $(evt).siblings('.jsc-charm-set-bundle__qty-input');
    var qty = parseInt($qtyInput.val());
    var newQty = qty + 1;
    $grid.find('.jsc-charm-set-bundle__qty-input').val(newQty);
    $grid.attr('active', '');
  }

  var $content = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${contentWrapIndex}"]`);
  $content.each(function() {
    updateSelectedCharmCount($(this));
  });
  addCharms($currentGrid);
  updateCharmSetBundleButton();
  calculateCharmSetBundlePrice();
  updateCharmOverlayImage();
}

updateCharmSetBundleButton = () => {
  var $charmSetWrap = null;
  if ($(window).width() > 480) {
    $charmSetWrap = $('.jsc-charm-set-bundle .jsc-charm-set-bundle__wrap .jsc-charm-set-bundle__desktop-content .jsc-charm-set-bundle__content-wrap');
  }
  else {
    $charmSetWrap = $('.jsc-charm-set-bundle .jsc-charm-set-bundle__wrap .jsc-charm-set-bundle__mobile-content .jsc-charm-set-bundle__content-wrap');
  }
  var $charmAtc = $('.product-content .jsc-charm-set-bundle-atc');
  var canAtc = true;

  if ($charmSetWrap.length > 0) {
    $charmSetWrap.each(function() {
      var minLimit = parseInt($(this).attr('item-limit-min'));
      var maxLimit = parseInt($(this).attr('item-limit-max'));
      var activeCount = getCharmSetActiveCount($(this));

      if (activeCount < minLimit || activeCount > maxLimit) {
        canAtc = false;
      }
    });

    if (canAtc == true) {
      $charmAtc.removeAttr('disabled');
    }
    else {
      $charmAtc.attr('disabled', '');
    }
  }
}

charmSetBundleATC = () => {
  var $activeGrids = null;
  if ($(window).width() > 480) {
    $activeGrids = $('.jsc-charm-set-bundle .jsc-charm-set-bundle__content.jsc-charm-set-bundle__desktop-content .jsc-charm-set-bundle__grid[active]');
  }
  else {
    $activeGrids = $('.jsc-charm-set-bundle .jsc-charm-set-bundle__content.jsc-charm-set-bundle__mobile-content .jsc-charm-set-bundle__grid[active]');
  }
  if ($activeGrids.length > 0) {
      var items = [];

      // main item
      var mainID = parseInt($('.product-content form[data-product-form] select[name="id"]').val());
      var seconds = new Date().getTime() / 1000;
      var bindID = mainID + '-' + seconds;
      var mainItem = {
          'id': mainID,
          'quantity': 1,
          'properties': {
              '_MainProduct': 'Yes',
              '_CharmSetMainProduct': 'Yes',
              '_BindID': bindID
          }
      };
      items.push(mainItem);

      // bundle item
      $activeGrids.each(function() {
          var id = parseInt($(this).attr('data-id'));
          var qty = 1;
          var $qtyInput = $(this).find('.jsc-charm-set-bundle__qty-input');
          if ($qtyInput.length > 0) {
            var qty = parseInt($qtyInput.val());
          }
          var bundleItem = {
              'id': id,
              'quantity': qty,
              'properties': {
                  '_BindID': bindID,
                  '_CharmSetBundle': 'Yes'
              }
          };

          items.push(bundleItem);
      });

      cartJSBulkAdd(items);
  }
}

calculateCharmSetBundlePrice = () => {
  var $charmSetContent = null;
  if ($(window).width() > 480) {
    $charmSetContent = $('.jsc-charm-set-bundle .jsc-charm-set-bundle__desktop-content .jsc-charm-set-bundle__content-wrap');
  }
  else {
    $charmSetContent = $('.jsc-charm-set-bundle .jsc-charm-set-bundle__mobile-content .jsc-charm-set-bundle__content-wrap');
  }
  if ($charmSetContent.length > 0) {
    var canAtc = true;
    var totalPrice = 0;
    var discountRate = 0.15;

    $charmSetContent.each(function() {
      var minLimit = parseInt($(this).attr('item-limit-min'));
      var maxLimit = parseInt($(this).attr('item-limit-max'));
      var activeCount = getCharmSetActiveCount($(this));

      if (activeCount < minLimit || activeCount > maxLimit) {
        canAtc = false;
      }

      var $activeGrids = $(this).find('.jsc-charm-set-bundle__grid[active]');
      $activeGrids.each(function(index, $grid) {
        var price = parseInt($($grid).attr('data-price'));
        var $qtyInput = $($grid).find('.jsc-charm-set-bundle__qty-input');
        if ($qtyInput.length > 0) {
          var qty = parseInt($qtyInput.val());
          price = price * qty;
        }
        totalPrice = totalPrice + price;
      });
    });

    var discountedPrice = totalPrice * (1 - discountRate);

    var $defaultPriceBlock = $('.jsc-pdp-price');
    var $bundlePriceDisplay = $('.jsc-bundle-price-display');
    var $atcButtonPrice = $('.jsc-charm-set-bundle-atc');

    if (canAtc == true) {
      $defaultPriceBlock.hide();
      $bundlePriceDisplay.css('display', 'flex');

      var $mainPrice = $bundlePriceDisplay.find('.jsc-bundle-main-price');
      var $comparePriceContainer = $bundlePriceDisplay.find('.jsc-bundle-compare-price-container');
      var $comparePriceElement = $comparePriceContainer.find('s');

      setBundlePriceEl($mainPrice, formatBundleMoney(Math.round(discountedPrice)));
      $comparePriceContainer.show();
      setBundlePriceEl($comparePriceElement, formatBundleMoney(totalPrice));

      setBundlePriceEl($atcButtonPrice.find('.jsc-charm-set-bundle-atc-price'), formatBundleMoney(Math.round(discountedPrice)));
      $atcButtonPrice.find('.jsc-charm-set-bundle-atc-compare-price').show();
      setBundlePriceEl(
        $atcButtonPrice.find('.jsc-charm-set-bundle-atc-compare-price [data-compare-price]'),
        formatBundleMoney(totalPrice)
      );
    }
    else {
      $defaultPriceBlock.show();
      $bundlePriceDisplay.hide();

      setBundlePriceEl($defaultPriceBlock.find('span[data-product-price]'), formatBundleMoney(totalPrice));
      $defaultPriceBlock.find('s[data-compare-price]').parent().hide();

      setBundlePriceEl($atcButtonPrice.find('.jsc-charm-set-bundle-atc-price'), formatBundleMoney(totalPrice));
      $atcButtonPrice.find('.jsc-charm-set-bundle-atc-compare-price').hide();
      setBundlePriceEl(
        $atcButtonPrice.find('.jsc-charm-set-bundle-atc-compare-price [data-compare-price]'),
        ''
      );
    }

    triggerBucksReConvert();
  }
}

updateCharmOverlayImage = () => {
  var $charmSetBundle = $('.jsc-charm-set-bundle');
  if ($charmSetBundle.length > 0) {
    var $overlayImageCont = $('.section-product .product-media .jsc-product-overlay-image .media:first');
    var $originalImageEl = $overlayImageCont.find('img:not(.jsc-appended-image)');
    var $charmContent = null;
    if ($(window).width() > 480) {
      $charmContents = $charmSetBundle.find('.jsc-charm-set-bundle__desktop-content .jsc-charm-set-bundle__content-wrap');
    }
    else {
      $charmContents = $charmSetBundle.find('.jsc-charm-set-bundle__mobile-content .jsc-charm-set-bundle__content-wrap');
    }

    $overlayImageCont.find('.jsc-appended-image').remove();
    var overlayPosition = undefined;
    var overlaySize = undefined;
    $charmContents.each(function(index, $contentWrap) {
      if (index == 0) {
        var $activeGrids = $($contentWrap).find('.jsc-charm-set-bundle__grid[active]');
        $activeGrids.each(function(gridIndex) {
          var overlayImage = $(this).attr('data-overlay');
          if (overlayImage != undefined) {
            var $overlayImgEl = $originalImageEl.clone(true);
            $overlayImgEl.attr('src', overlayImage);
            $overlayImgEl.removeAttr('srcset');
            $overlayImgEl.addClass('jsc-appended-image');
            $overlayImgEl.addClass('jsc-overlay-chain-image');
            $overlayImgEl.removeClass('jsc-overlay-charm-image');
            overlayPosition = $(this).attr('overlay-position');
            overlaySize = $(this).attr('overlay-size');
            $overlayImageCont.append($overlayImgEl);
          }
        });
      }
      else {
        selectedCharms.forEach(function(charm, index) {
          var overlayImage = charm.overlay;
          if (overlayImage != undefined) {
            var $overlayImgEl = $originalImageEl.clone(true);
            $overlayImgEl.attr('src', overlayImage);
            $overlayImgEl.removeAttr('srcset');
            $overlayImgEl.addClass('jsc-appended-image');
            $overlayImgEl.addClass('jsc-overlay-charm-image');
            $overlayImgEl.removeClass('jsc-overlay-chain-image');

            if (overlayPosition != undefined) {
              var positionList = overlayPosition.split('-');
              var currentPosition = positionList[index];
              var top = parseFloat(currentPosition.split(',')[0]);
              var left = parseFloat(currentPosition.split(',')[1]);
              var rotate = parseFloat(currentPosition.split(',')[2]);
              $overlayImgEl.css('top', `${top}%`);
              $overlayImgEl.css('left', `${left}%`);
              $overlayImgEl.css('transform', `rotate(${rotate}deg)`);
            }

            if (overlaySize != undefined) {
              $overlayImgEl.css('width', overlaySize);            
            }
            else {
              $overlayImgEl.css('width', '17%');
            }
            
            $overlayImageCont.append($overlayImgEl);
          }
        });
      }
    });
  }
}

showZoomImage = (evt) => {
  var imgSrc = $(evt).find('img').attr('src');
  var $imagePopup = $('.jsc-zoom-image__popup');
  var $overlay = $('.jsc-overlay');

  var $newImageEl = $('<img>');
  $newImageEl.attr('src', imgSrc);

  $imagePopup.find('.jsc-zoom-image__popup-inner').html('');
  $imagePopup.find('.jsc-zoom-image__popup-inner').append($newImageEl);

  $imagePopup.addClass('active');
  $overlay.addClass('active');
}

closeZoomImage = () => {
  var $imagePopup = $('.jsc-zoom-image__popup');
  var $overlay = $('.jsc-overlay');

  $imagePopup.removeClass('active');
  $overlay.removeClass('active');
}
// end: charm set bundle

textColumnAtc = (evt, event) => {
  event.preventDefault();
  var id = parseInt($(evt).attr('data-id'));
  cartJSAdd(id, 1, {});
}

// start: Bucks currency detection
initBucksCurrencyDetection = () => {
  const $currencyBox = $('.buckscc-currency-box');
  
  // If Bucks currency box not found, always show shipping
  if (!$currencyBox.length) {
    const $cartDrawer = $('#modals-rightDrawer');
    if ($cartDrawer.length > 0) {
      const $shippingProgress = $cartDrawer.find('.jsc-shipping-progress');
      if ($shippingProgress.length > 0) {
        $shippingProgress.show();
      }
    }
    return;
  }
  
  const toggleShipping = (show) => {
    const $cartDrawer = $('#modals-rightDrawer');
    if ($cartDrawer.length > 0) {
      const $shippingProgress = $cartDrawer.find('.jsc-shipping-progress');
      if ($shippingProgress.length > 0) {
        $shippingProgress.toggle(show);
      }
    }
  };
  
  const checkCurrency = () => {
    const $selected = $currencyBox.find('.bucks-selected');
    if ($selected.length) {
      const currencyText = $selected.text();
      const isUSD = currencyText.includes('USD');
      toggleShipping(isUSD);
    }
  };

  checkCurrency();

  // Listen for currency changes
  $currencyBox.on('click', () => {
    setTimeout(checkCurrency, 1000);
  });
  
  // Listen for cart drawer events
  document.addEventListener('theme:cart-drawer:open', () => {
    checkCurrency();
  });
  
  document.addEventListener('cart-is-open', () => {
    checkCurrency();
  });
  
  // Listen for cart updates
  document.addEventListener('theme:cart:change', () => {
    checkCurrency();
  });
  
  document.addEventListener('cart:updated', () => {
    checkCurrency();
  });
}
// end: Bucks currency detection
hideSmileBlocks = () => {
  // Find the closest buy buttons block
  const $addToCartButton = $('.product-block-buy-buttons .add-to-cart-btn');
  // console.log('$addToCartButton: ', $addToCartButton);
  if (!$addToCartButton.length) return;

  const $addToCartButtonDisplay = $addToCartButton.css('display');
  // console.log('$addToCartButtonDisplay: ', $addToCartButtonDisplay);
  if ($addToCartButtonDisplay !== 'none') return;

  const $buyButtonsBlock = $addToCartButton.closest('.product-block-buy-buttons');
  // Find Smile.io app blocks that are siblings
  const $smileBlocks = $buyButtonsBlock.siblings('.shopify-app-block[id*="_smile_io_smile"]');
  // console.log('$smileBlocks: ', $smileBlocks);

  if (!$smileBlocks.length) return;

  // Hide them
  $smileBlocks.hide();
}
// start: sticky add to cart watcher
initStickyAtcWatcher = () => {
  console.log('initStickyAtcWatcher');
  var defaultBottom = 30;
  
  // Track which elements have been found and set up
  var smileFound = false;
  var richpanelFound = false;
  
  // Wait for third-party elements to be injected by apps (checked separately)
  var findElementsInterval = setInterval(() => {
    
    // Check for Smile.io launcher
    if (!smileFound) {
      var $smile = $('#smile-ui-lite-launcher-frame-container');
      if ($smile.length > 0) {
        smileFound = true;
        console.log('Smile.io launcher found');
        setupElementObserver($smile, 'smile', defaultBottom);
      }
    }
    
    // Check for Richpanel icon
    if (!richpanelFound) {
      var $richpanel = $('.richpanel-micro .rp-micro-app-dummy-icon-container');
      if ($richpanel.length > 0) {
        richpanelFound = true;
        console.log('Richpanel icon found');
        setupElementObserver($richpanel, 'richpanel', defaultBottom);
      }
    }
    
    // If both elements are found, clear the interval
    if (smileFound && richpanelFound) {
      console.log('All third-party elements found - clearing interval');
      clearInterval(findElementsInterval);
    }
    
  }, 500);
  
  // Stop looking after 30 seconds if elements never load
  setTimeout(() => {
    if (!smileFound || !richpanelFound) {
      console.log('Stopped looking for third-party elements after 30s. Found:', {
        smile: smileFound,
        richpanel: richpanelFound
      });
    }
    clearInterval(findElementsInterval);
  }, 30000);
}

setupElementObserver = ($element, elementName, defaultBottom) => {
  var $stickyBar = $('.sticky-add-to-cart');
  
  if ($stickyBar.length === 0) {
    console.log('Sticky add to cart bar not found on this page');
    return;
  }
  
  var stickyBarElement = $stickyBar[0];
  var lastState = null;
  
  // Function to update element position
  var updatePosition = (isVisible) => {
    if (isVisible === lastState) return; // No change
    lastState = isVisible;
    
    var stickyBarHeight = $stickyBar.outerHeight() || 70;
    var newBottom = isVisible ? (stickyBarHeight + 15) : defaultBottom;
    
    if ($element && $element.length > 0) {
      $element[0].style.setProperty('bottom', newBottom + 'px', 'important');
      $element[0].style.setProperty('transition', 'bottom 0.3s ease', 'important');
      console.log(elementName + ' - Sticky ATC ' + (isVisible ? 'visible' : 'hidden') + ' - bottom:', newBottom + 'px');
    }
  };
  
  // Use MutationObserver to watch for style/attribute changes on sticky bar
  var observer = new MutationObserver((mutations) => {
    var isVisible = $stickyBar.is(':visible');
    updatePosition(isVisible);
  });
  
  // Observe style and class attribute changes
  observer.observe(stickyBarElement, {
    attributes: true,
    attributeFilter: ['style', 'class']
  });
  
  // Also check initial state
  var isVisible = $stickyBar.is(':visible');
  updatePosition(isVisible);
  
  console.log(elementName + ' observer initialized');
}
// end: sticky add to cart watcher

anchorToSection = (evt) => {
  var anchorLink = $(evt).attr('anchor-link');
  if (anchorLink != undefined) {
    var $anchorSection = $(`[anchor-id="${anchorLink}"]`);
    if ($anchorSection.length > 0) {
      // Get the sticky header height for offset
      var headerOffset = 0;
      var $header = $('header, .shopify-section-header, [data-section-type="header"]');
      if ($header.length > 0) {
        headerOffset = $header.outerHeight() || 0;
      }
      
      // Add extra padding (adjust as needed)
      var extraPadding = 100;
      
      // Calculate scroll position
      var elementPosition = $anchorSection.offset().top;
      var offsetPosition = elementPosition - headerOffset - extraPadding;
      
      // Smooth scroll to position
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
}

// start: product visualiser
updateVisualiserImage = (evt, imgSrc) => {
  var $visualiserImage = $(evt).parents('.jsc-product-visualiser-wrap').find('.jsc-product-visualiser-content-image img');
  $visualiserImage.attr('src', imgSrc);
  $visualiserImage.removeAttr('srcset');
  $(evt).addClass('active');
  $(evt).siblings().removeClass('active');
}
// end: product visualiser

wishlistPageStyling = () => {
  var listingSelector = '.wishlisthero-customer-view-listing';
  var cardSelector = '.wishlist-hero-list-card, .MuiGrid-item .MuiPaper-root.MuiCard-root';
  var descriptionClass = 'wishlist-hero-list-card-description';
  var titleClass = 'wishlist-hero-list-card-title-under-image';
  var variantClass = 'wishlist-hero-list-card-variant-title';
  var productCache = {};
  var pendingHandles = {};

  function stripHtml(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    return (tmp.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function formatTitle(text) {
    if (!text) {
      return '';
    }
    var parts = text.split('(');
    return parts[0].replace(/\s+$/, '');
  }

  function formatVariantLabel(text) {
    if (!text) {
      return '';
    }
    var startIndex = text.indexOf('(');
    if (startIndex === -1) {
      return '';
    }
    var label = text.slice(startIndex + 1);
    label = label.replace(')', '').trim();
    return label;
  }

  function resolveTitle(details, fallbackTitle) {
    var title = '';
    if (details) {
      title = details.title_primary || details.title || '';
    }
    if (!title) {
      title = fallbackTitle || '';
    }
    return formatTitle(title);
  }

  function resolveVariant(details, fallbackTitle) {
    if (details && details.variant_label) {
      return details.variant_label;
    }
    var sourceTitle = (details && details.title) ? details.title : fallbackTitle;
    return formatVariantLabel(sourceTitle || '');
  }

  function resolveDescription(details) {
    if (details && details.metafield) {
      return stripHtml(details.metafield);
    }
    if (details && details.source === 'json' && details.description) {
      return stripHtml(details.description);
    }
    return '';
  }

  function getExistingTitle(card) {
    var selectors = [
      '.wishlist-hero-list-card-header-product-name',
      '.wishlist-hero-list-card-product-name',
      '.MuiCardHeader-title',
      '.wishlist-hero-list-card-header a[href*="/products/"]',
      '.MuiCardHeader-root a[href*="/products/"]',
      '.wishlist-hero-list-card-header h1',
      '.wishlist-hero-list-card-header h2',
      '.wishlist-hero-list-card-header h3',
      '.MuiCardHeader-root h1',
      '.MuiCardHeader-root h2',
      '.MuiCardHeader-root h3',
      '.wishlist-hero-list-card-header .MuiTypography-root',
      '.MuiCardHeader-root .MuiTypography-root'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var el = card.querySelector(selectors[i]);
      if (el && !el.classList.contains(titleClass)) {
        var text = stripHtml(el.textContent);
        if (!text) {
          continue;
        }
        var href = el.getAttribute('href') || '';
        if (!href) {
          var link = el.closest('a[href*="/products/"]');
          if (link) {
            href = link.href;
          }
        }
        return {
          element: el,
          text: text,
          href: href
        };
      }
    }

    return {
      element: null,
      text: '',
      href: ''
    };
  }

  function hideElement(element) {
    if (!element) {
      return;
    }
    element.style.display = 'none';
    element.setAttribute('aria-hidden', 'true');
  }

  var heartIconTemplate = null;
  var heartIconSource = '';

  function cloneIconNode(node) {
    if (!node) {
      return null;
    }

    var clone = node.cloneNode(true);
    clone.removeAttribute('id');
    var nodesWithId = clone.querySelectorAll('[id]');
    for (var i = 0; i < nodesWithId.length; i += 1) {
      nodesWithId[i].removeAttribute('id');
    }
    return clone;
  }

  function buildFallbackHeartIcon() {
    var wrapper = document.createElement('span');
    wrapper.innerHTML =
      '<svg class="wishlist-hero-heart-icon" viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
      '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M24 36.093 12.068 23.805a6.9 6.9 0 0 1-1.323-8.044v0a7.108 7.108 0 0 1 11.307-1.81L24 15.726l1.948-1.777a7.112 7.112 0 0 1 11.308 1.81v0a6.902 6.902 0 0 1-1.324 8.045L24 36.093Z"/>' +
      '</svg>';
    return wrapper.firstElementChild;
  }

  function findReferenceHeartIcon() {
    var selectors = [
      '.product-tile__container .swym-button.swym-add-to-wishlist-view-product:not(.swym-added) img',
      '.product-tile__container .swym-button.swym-add-to-wishlist-view-product:not(.swym-added) svg',
      '.product-tile__container .swym-button.swym-add-to-wishlist-view-product:not(.swym-added) [data-icon]',
      '.product-tile__container .swym-button.swym-add-to-wishlist-view-product img',
      '.product-tile__container .swym-button.swym-add-to-wishlist-view-product svg',
      '.product-tile__container .swym-button.swym-add-to-wishlist-view-product [data-icon]',
      '.wishlist-hero-custom-button [data-icon="heart"]',
      '.wishlist-hero-custom-button svg',
      '.wishlist-hero-custom-button img',
      '.wishlisthero-floating [data-icon="heart"]',
      '.wishlisthero-floating svg',
      '.wishlisthero-floating img'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var node = document.querySelector(selectors[i]);
      if (node) {
        return {
          node: node,
          source: selectors[i].indexOf('.product-tile__container') === 0 ? 'product-tile' : 'wishlist-hero'
        };
      }
    }

    return null;
  }

  function setHeartIconTemplate(node, source) {
    var clone = cloneIconNode(node);
    if (!clone) {
      return;
    }
    heartIconTemplate = clone;
    heartIconSource = source || '';
  }

  function getHeartIconTemplate() {
    if (!heartIconTemplate || heartIconSource === 'fallback') {
      var reference = findReferenceHeartIcon();
      if (reference && reference.node) {
        setHeartIconTemplate(reference.node, reference.source);
      } else if (!heartIconTemplate) {
        setHeartIconTemplate(buildFallbackHeartIcon(), 'fallback');
      }
    }

    return cloneIconNode(heartIconTemplate);
  }

  function updateDeleteIcon(card) {
    var deleteButton = card.querySelector('.wishlist-hero-list-card-footer-delete');
    if (!deleteButton) {
      return;
    }

    var iconWrapper = deleteButton.querySelector('.wishlist-hero-delete-icon');
    if (!iconWrapper) {
      iconWrapper = document.createElement('span');
      iconWrapper.className = 'wishlist-hero-delete-icon';
      deleteButton.appendChild(iconWrapper);
    }

    var iconTemplate = getHeartIconTemplate();
    if (iconTemplate) {
      if (iconWrapper.getAttribute('data-source') !== heartIconSource) {
        iconWrapper.innerHTML = '';
        iconWrapper.appendChild(iconTemplate);
        iconWrapper.setAttribute('data-source', heartIconSource);
      }
    }

    if (!deleteButton.getAttribute('aria-label')) {
      deleteButton.setAttribute('aria-label', 'Remove from wishlist');
    }
  }

  function getProductMeta(card, fallbackUrl) {
    var link = card.querySelector('a[href*="/products/"]');
    var linkUrl = link ? link.href : fallbackUrl;
    if (!linkUrl) {
      return null;
    }

    if (!link) {
      link = { href: linkUrl };
    }

    try {
      var url = new URL(linkUrl, window.location.origin);
      var match = url.pathname.match(/^(.*\/products\/)([^\/\?#]+)/);
      if (!match) {
        return null;
      }
      return {
        handle: match[2],
        metaUrl: match[1] + match[2] + '?view=wishlist-meta',
        jsonUrl: match[1] + match[2] + '.js',
        productUrl: link.href
      };
    } catch (error) {
      return null;
    }
  }

  function insertTitleUnderImage(card, text, productUrl) {
    var titleText = formatTitle(text);
    if (!titleText) {
      return;
    }

    var titleWrapper = card.querySelector('.' + titleClass);
    var titleHeading = null;

    if (!titleWrapper) {
      titleWrapper = document.createElement(productUrl ? 'a' : 'div');
      titleWrapper.className = titleClass;
      if (productUrl) {
        titleWrapper.href = productUrl;
      }

      titleHeading = document.createElement('h3');
      titleHeading.className = 'jsc-grid-product-title font-body text-base';
      titleHeading.textContent = titleText;
      titleWrapper.appendChild(titleHeading);

      var imageEl = card.querySelector('.wishlist-hero-list-card-product-image, .MuiCardMedia-root');
      if (imageEl && imageEl.parentElement) {
        imageEl.after(titleWrapper);
        return;
      }

      var priceContainer = card.querySelector('.MuiCardContent-root');
      if (priceContainer && priceContainer.parentElement) {
        priceContainer.parentElement.insertBefore(titleWrapper, priceContainer);
        return;
      }

      card.insertBefore(titleWrapper, card.firstChild);
      return;
    }

    titleHeading = titleWrapper.querySelector('h3');
    if (!titleHeading) {
      titleHeading = document.createElement('h3');
      titleHeading.className = 'jsc-grid-product-title font-body text-base';
      titleWrapper.appendChild(titleHeading);
    }

    if (titleHeading.textContent !== titleText) {
      titleHeading.textContent = titleText;
    }
    if (productUrl && titleWrapper.tagName.toLowerCase() === 'a' && titleWrapper.getAttribute('href') !== productUrl) {
      titleWrapper.setAttribute('href', productUrl);
    }
  }

  function insertVariantTitle(card, text) {
    var variantEl = card.querySelector('.' + variantClass);
    if (!text) {
      if (variantEl) {
        variantEl.remove();
      }
      return;
    }

    if (!variantEl) {
      variantEl = document.createElement('div');
      variantEl.className = variantClass;
    }
    variantEl.classList.add('jsc-product-title-split-color', 'text-scheme-text');

    if (variantEl.textContent !== text) {
      variantEl.textContent = text;
    }

    var linkWrapper = card.querySelector('.MuiTypography-root.MuiLink-root.MuiLink-underlineHover.MuiTypography-colorInherit');
    if (linkWrapper) {
      if (variantEl.parentElement !== linkWrapper.parentElement || variantEl.previousSibling !== linkWrapper) {
        linkWrapper.after(variantEl);
      }
      return;
    }

    var titleEl = card.querySelector('.' + titleClass);
    if (titleEl) {
      if (variantEl.parentElement !== titleEl.parentElement) {
        titleEl.after(variantEl);
      }
      return;
    }

    var header = card.querySelector('.wishlist-hero-list-card-header, .MuiCardHeader-root');
    if (header) {
      if (variantEl.parentElement !== header) {
        header.appendChild(variantEl);
      }
      return;
    }

    var priceContainer = card.querySelector('.MuiCardContent-root') || card;
    if (variantEl.parentElement !== priceContainer) {
      priceContainer.insertBefore(variantEl, priceContainer.firstChild);
    }
  }

  function insertDescription(card, text) {
    var descriptionEl = card.querySelector('.' + descriptionClass);
    if (!text) {
      if (descriptionEl) {
        descriptionEl.remove();
      }
      return;
    }

    if (!descriptionEl) {
      descriptionEl = document.createElement('p');
      descriptionEl.className = descriptionClass;
    }

    if (descriptionEl.textContent !== text) {
      descriptionEl.textContent = text;
    }

    var priceEl = card.querySelector('.wishlist-hero-price-update, .wishlist-hero-list-card-price, .MuiTypography-root, .money');
    var priceContainer = card.querySelector('.MuiCardContent-root') || card;

    if (priceEl && priceEl.parentElement === priceContainer) {
      if (descriptionEl.parentElement !== priceContainer) {
        priceEl.after(descriptionEl);
      }
    } else {
      if (descriptionEl.parentElement !== priceContainer) {
        priceContainer.appendChild(descriptionEl);
      }
    }
  }

  function buildDetailsFromMeta(data) {
    if (!data) {
      return null;
    }
    return {
      source: 'meta',
      title: data.title || '',
      title_primary: data.title_primary || '',
      variant_label: data.variant_label || '',
      metafield: data.metafield || '',
      url: data.url || ''
    };
  }

  function buildDetailsFromProductJson(product) {
    if (!product) {
      return null;
    }
    return {
      source: 'json',
      title: product.title || '',
      description: product.description || ''
    };
  }

  function fetchProductDetails(meta) {
    return fetch(meta.metaUrl, {
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Wishlist Hero meta fetch failed');
        }
        return response.json();
      })
      .then(function(data) {
        return buildDetailsFromMeta(data);
      })
      .catch(function() {
        return fetch(meta.jsonUrl)
          .then(function(response) {
            if (!response.ok) {
              throw new Error('Wishlist Hero product fetch failed');
            }
            return response.json();
          })
          .then(function(product) {
            return buildDetailsFromProductJson(product);
          })
          .catch(function() {
            return null;
          });
      });
  }

  function applyDetails(card, details, fallbackTitle, fallbackUrl) {
    var titleText = resolveTitle(details, fallbackTitle);
    var variantText = resolveVariant(details, fallbackTitle);
    var descriptionText = resolveDescription(details);
    var linkUrl = (details && details.url) ? details.url : fallbackUrl;

    insertTitleUnderImage(card, titleText, linkUrl);
    insertVariantTitle(card, variantText);
    insertDescription(card, descriptionText);
  }

  function ensureDetails(card) {
    if (!card) {
      return;
    }

    updateDeleteIcon(card);

    var existingTitle = getExistingTitle(card);
    if (existingTitle.element) {
      hideElement(existingTitle.element);
    }

    var meta = getProductMeta(card, existingTitle.href);
    var fallbackTitle = existingTitle.text;
    var fallbackUrl = meta ? (meta.productUrl || existingTitle.href) : existingTitle.href;

    applyDetails(card, null, fallbackTitle, fallbackUrl);

    if (!meta) {
      return;
    }

    var cachedDetails = productCache[meta.handle];
    if (cachedDetails) {
      applyDetails(card, cachedDetails, fallbackTitle, fallbackUrl);
      return;
    }

    if (pendingHandles[meta.handle]) {
      return;
    }

    pendingHandles[meta.handle] = true;
    fetchProductDetails(meta)
      .then(function(details) {
        if (details) {
          productCache[meta.handle] = details;
        }
        updateWishlistDetails();
      })
      .catch(function() {})
      .finally(function() {
        pendingHandles[meta.handle] = false;
      });
  }

  function updateWishlistDetails() {
    var cards = document.querySelectorAll(listingSelector + ' ' + cardSelector);
    cards.forEach(function(card) {
      ensureDetails(card);
    });
    ensureEmptyWishlistCta();
  }

  function ensureEmptyWishlistCta() {
    var emptyContainer = document.querySelector('.wishlist-hero-list-no-items-content');
    var ctaWrapper = document.querySelector('.wishlist-hero-empty-cta');
    var itemSelector =
      '.wishlisthero-customer-view-listing .MuiGrid-item .MuiCardMedia-root,' +
      ' .wishlisthero-customer-view-listing .wishlist-hero-list-card-product-image';
    var hasItems = document.querySelectorAll(itemSelector).length > 0;

    if (hasItems || !emptyContainer) {
      if (ctaWrapper) {
        ctaWrapper.remove();
      }
      return;
    }

    if (ctaWrapper) {
      return;
    }

    var emptyText = emptyContainer.querySelector('.wishlist-hero-list-no-items-text');
    ctaWrapper = document.createElement('div');
    ctaWrapper.className = 'wishlist-hero-empty-cta';

    var ctaLink = document.createElement('a');
    ctaLink.href = '/';
    ctaLink.className = 'push-btn inline-block';

    var ctaSurface = document.createElement('span');
    ctaSurface.className = 'push-btn__surface';
    ctaSurface.textContent = 'Start Shopping';

    // ctaLink.appendChild(ctaSurface);
    // ctaWrapper.appendChild(ctaLink);

    if (emptyText && emptyText.parentElement === emptyContainer) {
      emptyText.after(ctaWrapper);
    } else {
      emptyContainer.appendChild(ctaWrapper);
    }

    var collectionsTemplate = document.getElementById('wishlist-hero-empty-collections-template');
    if (collectionsTemplate && !ctaWrapper.querySelector('.wishlist-hero-empty-collections')) {
      if (collectionsTemplate.content) {
        ctaWrapper.appendChild(collectionsTemplate.content.cloneNode(true));
      } else {
        ctaWrapper.insertAdjacentHTML('beforeend', collectionsTemplate.innerHTML);
      }
    }
  }

  updateWishlistDetails();

  var appContainer = document.querySelector('#wishlist-hero-shared-list-view') || document.body;
  var observer = new MutationObserver(function() {
    updateWishlistDetails();
  });
  observer.observe(appContainer, {
    childList: true,
    subtree: true
  });
}

// start: product tabs anchor links
// Intercepts clicks on anchor links within product tabs content (from rich text editor)
// and scrolls to matching [anchor-id] elements on the page
initProductTabsAnchorLinks = () => {
  $(document).on('click', '.product-tabs__content a[href*="#"]', function(e) {
    var href = $(this).attr('href');
    console.log('Product tabs anchor link clicked:', href);
    
    // Extract the anchor portion (after #)
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;
    
    var anchorTarget = href.substring(hashIndex + 1);
    if (!anchorTarget) return;
    
    // Remove leading # if user accidentally included it in anchor-id
    var anchorTargetClean = anchorTarget.replace(/^#/, '');
    
    console.log('Looking for anchor target:', anchorTargetClean);
    
    // Look for element with matching anchor-id attribute (without #)
    var $anchorSection = $('[anchor-id="' + anchorTargetClean + '"]');
    
    // Also try with # in case user added it that way
    if ($anchorSection.length === 0) {
      $anchorSection = $('[anchor-id="#' + anchorTargetClean + '"]');
    }
    
    // If no anchor-id match, also try matching by id attribute as fallback
    if ($anchorSection.length === 0) {
      $anchorSection = $('#' + anchorTargetClean);
    }
    
    console.log('Found anchor section:', $anchorSection.length > 0 ? 'Yes' : 'No');
    
    if ($anchorSection.length > 0) {
      e.preventDefault();
      
      // Get the sticky header height for offset
      var headerOffset = 0;
      var $header = $('header, .shopify-section-header, [data-section-type="header"]');
      if ($header.length > 0) {
        headerOffset = $header.outerHeight() || 0;
      }
      
      // Add extra padding (adjust as needed)
      var extraPadding = 100;
      
      // Calculate scroll position
      var elementPosition = $anchorSection.offset().top;
      var offsetPosition = elementPosition - headerOffset - extraPadding;
      
      console.log('Scrolling to position:', offsetPosition);
      
      // Smooth scroll to position
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  });
}
// end: product tabs anchor links

alignProductGridTitleRows = () => {
  var grids = document.querySelectorAll('.grid');
  grids.forEach(function(grid) {
    var cells = grid.querySelectorAll(':scope > *');
    var titleRows = [];
    cells.forEach(function(cell) {
      var row = cell.querySelector('.jsc-grid-title-row');
      if (row) titleRows.push(row);
    });
    if (!titleRows.length) return;

    titleRows.forEach(function(row) { row.style.minHeight = ''; });
    var style = window.getComputedStyle(grid);
    var cols = style.gridTemplateColumns;
    var colCount = cols && cols !== 'none' ? cols.split(' ').filter(Boolean).length : 1;
    if (colCount < 1) colCount = 1;

    for (var i = 0; i < titleRows.length; i += colCount) {
      var rowMax = 0;
      var slice = [];
      for (var j = 0; j < colCount && i + j < titleRows.length; j++) {
        var el = titleRows[i + j];
        slice.push(el);
        rowMax = Math.max(rowMax, el.getBoundingClientRect().height);
      }
      slice.forEach(function(el) { el.style.minHeight = rowMax + 'px'; });
    }
  });
};

initAlignProductGridTitleRows = () => {
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(alignProductGridTitleRows, 100);
  });
  var results = document.getElementById('facets-results');
  if (results) {
    var mo = new MutationObserver(function() {
      setTimeout(alignProductGridTitleRows, 0);
    });
    mo.observe(results, { childList: true, subtree: true });
  }
};

initProductTileTouchReveal = () => {
  var touchRevealTimeout;
  document.addEventListener('touchstart', function(e) {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    var wrapper = e.target.closest('.product-tile__media-wrapper');
    if (!wrapper) return;
    var tile = wrapper.closest('.product-tile');
    if (!tile) return;
    clearTimeout(touchRevealTimeout);
    document.querySelectorAll('.product-tile.jsc-tile-touch-revealed').forEach(function(t) {
      if (t !== tile) t.classList.remove('jsc-tile-touch-revealed');
    });
    tile.classList.add('jsc-tile-touch-revealed');
    touchRevealTimeout = setTimeout(function() {
      tile.classList.remove('jsc-tile-touch-revealed');
    }, 2500);
  }, { passive: true });
};

initProductTileSwatchSelection = () => {
  var hoverMq = window.matchMedia('(hover: hover)');
  var quickBuyProductCache = {};

  function jscParsePriceCents(price) {
    if (price == null || price === '') return 0;
    if (typeof price === 'string') {
      var n = parseFloat(String(price).replace(/[^\d.]/g, ''));
      return isNaN(n) ? 0 : Math.round(n * 100);
    }
    if (typeof price === 'number') return Math.round(price);
    return 0;
  }

  function jscFormatMoneyStrip(cents) {
    if (typeof formatMoney !== 'function' || !window.theme || !theme.moneyFormat) return String(cents);
    return ensureMoneyWrapper(formatMoney(cents, theme.moneyFormat).replace(/MYR/gi, '').trim());
  }

  function jscSetPriceElement(el, cents) {
    if (!el) return;
    var formatted = jscFormatMoneyStrip(cents);
    if (!formatted) return;
    if (formatted.indexOf('<') !== -1) {
      el.innerHTML = formatted;
    } else {
      el.textContent = formatted;
    }
  }

  function normalizeProductForQuickBuy(json) {
    var product = JSON.parse(JSON.stringify(json));
    var variants = product.variants || [];
    product.variants = variants.map(function (v) {
      var opts = [];
      if (v.option1 != null && v.option1 !== '') opts.push(v.option1);
      if (v.option2 != null && v.option2 !== '') opts.push(v.option2);
      if (v.option3 != null && v.option3 !== '') opts.push(v.option3);
      var fi = v.featured_image;
      var featured_media =
        fi && typeof fi === 'object' && fi.id != null
          ? { id: fi.id }
          : null;
      return Object.assign({}, v, {
        price: jscParsePriceCents(v.price),
        compare_at_price:
          v.compare_at_price != null && v.compare_at_price !== ''
            ? jscParsePriceCents(v.compare_at_price)
            : null,
        options: opts,
        featured_media: featured_media,
      });
    });
    if (!product.options) product.options = [];
    var minPrice = Infinity;
    var maxCompare = 0;
    product.variants.forEach(function (v) {
      if (v.price < minPrice) minPrice = v.price;
      if (v.compare_at_price && v.compare_at_price > maxCompare) maxCompare = v.compare_at_price;
    });
    product.price = minPrice === Infinity ? 0 : minPrice;
    product.compare_at_price_max = maxCompare;
    return product;
  }

  function swatchImgState(tile) {
    if (!tile._jscSwatchImg) {
      var img = tile.querySelector('img.jsc-product-tile-primary-img');
      if (!img) return null;
      tile._jscSwatchImg = {
        img: img,
        baseSrc: img.getAttribute('src'),
        baseSrcset: img.getAttribute('srcset'),
      };
    }
    return tile._jscSwatchImg;
  }

  function swatchHoverImgState(tile) {
    if (!tile._jscSwatchHoverImg) {
      var hoverImg = tile.querySelector('img.jsc-product-tile-hover-img');
      if (!hoverImg) return null;
      tile._jscSwatchHoverImg = {
        img: hoverImg,
        baseSrc: hoverImg.getAttribute('src'),
        baseSrcset: hoverImg.getAttribute('srcset'),
      };
    }
    return tile._jscSwatchHoverImg;
  }

  function applyTileImage(tile, src, srcset) {
    var s = swatchImgState(tile);
    if (!s || !src) return;
    s.img.setAttribute('src', src);
    if (srcset) s.img.setAttribute('srcset', srcset);
    else s.img.removeAttribute('srcset');
  }

  function activeSwatchButton(tile) {
    return tile.querySelector('.jsc-siblings-swatch-opt.active');
  }

  function applyImageFromButton(tile, btn) {
    if (!btn) return;
    var src = btn.getAttribute('data-preview-src');
    var srcset = btn.getAttribute('data-preview-srcset') || '';
    if (src) applyTileImage(tile, src, srcset);
  }

  function applyHoverImageFromButton(tile, btn) {
    if (!btn) return;
    var s = swatchHoverImgState(tile);
    if (!s || !s.img) return;
    var src = btn.getAttribute('data-hover-src') || btn.getAttribute('data-preview-src') || '';
    var srcset =
      btn.getAttribute('data-hover-srcset') ||
      btn.getAttribute('data-preview-srcset') ||
      '';
    if (!src) {
      if (s.baseSrc) s.img.setAttribute('src', s.baseSrc);
      else s.img.removeAttribute('src');
      if (s.baseSrcset) s.img.setAttribute('srcset', s.baseSrcset);
      else s.img.removeAttribute('srcset');
      return;
    }
    s.img.setAttribute('src', src);
    if (srcset) s.img.setAttribute('srcset', srcset);
    else s.img.removeAttribute('srcset');
  }

  function updateLinksAndWishlist(tile, btn, pdpUrl) {
    if (!btn && !pdpUrl) return;
    var url = pdpUrl || (btn && btn.getAttribute('data-sibling-url')) || '';
    var listingUrl = tile.getAttribute('data-jsc-listing-product-url') || '';
    var siblingId = btn ? btn.getAttribute('data-sibling-id') : '';
    var variantId = btn ? btn.getAttribute('data-variant-id') : '';
    var title = btn ? btn.getAttribute('data-sibling-title') : '';
    var wlhImg = btn ? btn.getAttribute('data-wlh-image') : '';
    var wlhPrice = btn ? btn.getAttribute('data-wlh-price') : '';

    if (btn && String(btn.getAttribute('data-sibling-id')) === String(tile.getAttribute('data-jsc-listing-product-id'))) {
      url = listingUrl;
    }

    var mediaLink = tile.querySelector('[data-jsc-product-tile-media-link]');
    var titleLink = tile.querySelector('[data-jsc-product-tile-title-link]');
    if (mediaLink && url) mediaLink.setAttribute('href', url);
    if (titleLink && url) titleLink.setAttribute('href', url);

    var fcViewDetails = tile.querySelector('a.jsc-fc-custom-view-details');
    if (fcViewDetails && url) fcViewDetails.setAttribute('href', url);

    var wl = tile.querySelector('[data-jsc-wishlist-hero]');
    if (wl && btn) {
      if (siblingId) wl.setAttribute('data-wlh-id', siblingId);
      if (url) wl.setAttribute('data-wlh-link', url);
      if (variantId) wl.setAttribute('data-wlh-variantid', variantId);
      if (title) wl.setAttribute('data-wlh-name', title);
      if (wlhImg) wl.setAttribute('data-wlh-image', wlhImg);
      if (wlhPrice) wl.setAttribute('data-wlh-price', wlhPrice);
    }
  }

  function updateStaticTilePrice(tile, btn) {
    if (!btn) return;
    var island = tile.querySelector('data-island[src*="island-quick-buy"]');
    if (island) return;

    var priceCents = parseInt(btn.getAttribute('data-price'), 10);
    if (isNaN(priceCents)) return;
    var compareRaw = btn.getAttribute('data-compare-at-price');
    var compareCents = compareRaw != null && compareRaw !== '' ? parseInt(compareRaw, 10) : null;
    var onSale = compareCents != null && !isNaN(compareCents) && compareCents > priceCents;

    var root = tile.querySelector('.jsc-grid-price .price');
    if (!root) return;

    root.classList.toggle('price--on-sale', !!onSale);

    var regBlock = root.querySelector('.price__regular');
    var saleBlock = root.querySelector('.price__sale');
    var regItem = root.querySelector('.price__regular .price-item--regular');
    var saleItem = root.querySelector('.price__sale .price-item--sale');
    var strike = root.querySelector('.price__sale s.price-item--regular');

    jscSetPriceElement(regItem, priceCents);
    jscSetPriceElement(saleItem, priceCents);
    if (strike && onSale) jscSetPriceElement(strike, compareCents);

    if (regBlock) regBlock.classList.toggle('hidden', !!onSale);
    if (saleBlock) saleBlock.classList.toggle('hidden', !onSale);

    triggerBucksReConvert();
  }

  function syncQuickBuyForm(ctx, normalized, variant) {
    var form = ctx.productRoot && ctx.productRoot.querySelector('.quick-buy-product-form');
    if (!form || !variant) return;

    var select = form.querySelector('select[name="id"]');
    var hidden = form.querySelector('input[type="hidden"][name="id"]');

    if (select && normalized.variants && normalized.variants.length) {
      select.innerHTML = '';
      normalized.variants.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = String(v.id);
        opt.textContent = v.title || v.name || 'Variant';
        opt.disabled = !v.available;
        select.appendChild(opt);
      });
      select.value = String(variant.id);
      select.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      ctx.updateVariant(variant);
      if (hidden) hidden.value = String(variant.id);
    }
    if (normalized.handle) {
      form.setAttribute('data-product-handle', normalized.handle);
    }
  }

  /**
   * Featured collection (custom): update the quick-buy form DOM immediately from swatch data
   * so Add to cart uses the correct variant before async Alpine/product JSON sync finishes.
   */
  function syncFcCustomQuickBuyFormFromSwatch(tile, btn) {
    if (!tile || !btn || !tile.classList.contains('jsc-product-tile--fc-custom')) return;
    var island = tile.querySelector('data-island[src*="island-quick-buy"]');
    if (!island) return;
    var form = island.querySelector('.quick-buy-product-form');
    if (!form) return;
    var variantId = btn.getAttribute('data-variant-id');
    var handle = btn.getAttribute('data-sibling-handle');
    var hidden = form.querySelector('input[type="hidden"][name="id"]');
    if (hidden && variantId) hidden.value = String(variantId);
    if (handle) form.setAttribute('data-product-handle', handle);
  }

  function fetchProductAndSyncQuickBuy(tile, btn) {
    var handle = btn.getAttribute('data-sibling-handle');
    if (!handle) return;

    var cached = quickBuyProductCache[handle];
    var productRequest = cached
      ? Promise.resolve(cached)
      : (function () {
          var root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
          if (root.slice(-1) !== '/') root += '/';
          var url = root + 'products/' + encodeURIComponent(handle) + '.js';
          return fetch(url)
            .then(function (res) {
              if (!res.ok) throw new Error('product fetch');
              return res.json();
            })
            .then(function (json) {
              quickBuyProductCache[handle] = json;
              return json;
            });
        })();

    productRequest
      .then(function (json) {
        var normalized = normalizeProductForQuickBuy(json);
        var want = btn.getAttribute('data-variant-id');
        var variant = null;
        if (want) {
          var wid = parseInt(want, 10);
          variant = (normalized.variants || []).find(function (v) {
            return Number(v.id) === wid;
          });
        }
        if (!variant) {
          variant =
            (normalized.variants || []).find(function (v) {
              return v.available;
            }) || (normalized.variants || [])[0];
        }

        var island = tile.querySelector('data-island[src*="island-quick-buy"]');
        if (!island || !variant) return;

        function applyCtx(attempt) {
          attempt = attempt || 0;
          if (attempt > 40) return;
          var ctx = null;
          try {
            if (typeof Alpine !== 'undefined' && typeof Alpine.$data === 'function') {
              ctx = Alpine.$data(island);
            }
          } catch (err) {}
          if (!ctx || typeof ctx.updateVariant !== 'function') {
            setTimeout(function () {
              applyCtx(attempt + 1);
            }, 50);
            return;
          }
          ctx.product = normalized;
          ctx.$nextTick(function () {
            syncQuickBuyForm(ctx, normalized, variant);
            var bisBtn = tile.querySelector('.product-quick-buy__container .BIS_trigger');
            if (bisBtn && json) {
              try {
                bisBtn.setAttribute('data-product-data', JSON.stringify(json));
                if (variant && variant.id != null) {
                  bisBtn.setAttribute('data-variant-id', String(variant.id));
                }
              } catch (e) {}
            }
          });
        }
        applyCtx(0);

        if (json && json.url) updateLinksAndWishlist(tile, btn, json.url);
      })
      .catch(function () {});
  }

  function setActiveButton(wrap, btn) {
    wrap.querySelectorAll('.jsc-siblings-swatch-opt').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var item = b.closest('.jsc-siblings-swatch-item');
      if (item) item.classList.toggle('jsc-siblings-swatch-item--active', on);
    });
  }

  function commitSelection(tile, btn) {
    if (!tile || !btn) return;
    var wrap = btn.closest('.jsc-siblings-swatch-wrap');
    if (!wrap) return;
    var alreadyActive = btn.classList.contains('active');

    setActiveButton(wrap, btn);
    applyImageFromButton(tile, btn);
    applyHoverImageFromButton(tile, btn);
    updateLinksAndWishlist(tile, btn, null);
    updateStaticTilePrice(tile, btn);

    if (tile.classList.contains('jsc-product-tile--fc-custom') && btn) {
      var sid = btn.getAttribute('data-sibling-id');
      var vid = btn.getAttribute('data-variant-id');
      if (sid) tile.setAttribute('data-jsc-listing-product-id', sid);
      if (vid) tile.setAttribute('data-jsc-listing-variant-id', vid);
      syncFcCustomQuickBuyFormFromSwatch(tile, btn);
    }

    if (!tile.classList.contains('jsc-product-tile--fc-custom')) {
      var siblingUrl = btn.getAttribute('data-sibling-url');
      var viewOpt = tile.querySelector('.product-quick-buy__container a.push-btn');
      if (viewOpt && siblingUrl) viewOpt.setAttribute('href', siblingUrl);
    }

    if (!alreadyActive && tile.querySelector('data-island[src*="island-quick-buy"]')) {
      fetchProductAndSyncQuickBuy(tile, btn);
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('button.jsc-siblings-swatch-opt');
      if (!btn) return;
      var tile = btn.closest('.product-tile');
      if (!tile) return;
      commitSelection(tile, btn);
    },
    true
  );

  document.addEventListener(
    'mouseover',
    function (e) {
      if (!hoverMq.matches) return;
      var btn = e.target.closest('button.jsc-siblings-swatch-opt');
      if (!btn) return;
      var tile = btn.closest('.product-tile');
      if (!tile) return;
      if (tile.classList.contains('jsc-product-tile--fc-custom')) return;
      commitSelection(tile, btn);
    },
    true
  );

  function initFcCustomFeaturedCollectionSwatches() {
    if (typeof $ === 'undefined' || !$('.jsc-featured-collection-custom').length) return;

    $('.jsc-featured-collection-custom .jsc-product-tile--fc-custom .jsc-siblings-swatch-wrap').each(function () {
      var wrap = this;
      var tile = $(wrap).closest('.product-tile')[0];
      var first = $(wrap).find('.jsc-siblings-swatch-opt').get(0);
      if (!tile || !first) return;

      $(wrap)
        .find('.jsc-siblings-swatch-opt')
        .each(function () {
          this.classList.remove('active');
          this.setAttribute('aria-pressed', 'false');
        });

      commitSelection(tile, first);
    });
  }

  initFcCustomFeaturedCollectionSwatches();

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.classList || !e.target.classList.contains('jsc-featured-collection-custom')) return;
    initFcCustomFeaturedCollectionSwatches();
  });
};

initProductTileSwatchClick = () => {
  var lastTouchWrap = null;
  var lastTouchTime = 0;

  function toggleSwatches(wrap) {
    document.querySelectorAll('.jsc-product-title-split-color-wrap.is-expanded').forEach(function(other) {
      if (other !== wrap) other.classList.remove('is-expanded');
    });
    wrap.classList.toggle('is-expanded');
  }

  document.addEventListener('touchstart', function(e) {
    if (!window.matchMedia('(hover: none)').matches) return;
    if (!e.target.closest('.jsc-product-title-split-color-text')) return;
    var wrap = e.target.closest('.jsc-product-title-split-color-wrap');
    if (!wrap) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    lastTouchWrap = wrap;
    lastTouchTime = Date.now();
    toggleSwatches(wrap);
  }, true);

  document.addEventListener('click', function(e) {
    if (!window.matchMedia('(hover: none)').matches) return;

    var wrap = e.target.closest('.jsc-product-title-split-color-wrap');
    if (wrap && lastTouchWrap === wrap && (Date.now() - lastTouchTime) < 400) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return;
    }

    if (!e.target.closest('.jsc-product-title-split-color-text')) return;
    if (!wrap) wrap = e.target.closest('.jsc-product-title-split-color-wrap');
    if (!wrap) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    toggleSwatches(wrap);
  }, true);
};

initBucksCurrencyEventListener = () => {
  if (window.__jscBucksCurrencyEventBound) return;

  const eventName = 'BUCKS_SELECTED_CURRENCY';
  const handleCurrencyChange = (event) => {
    const selectedCurrency = event && event.detail;
    if (!selectedCurrency) return;

    window.jscCurrentBucksCurrency = selectedCurrency;
    document.documentElement.setAttribute('data-jsc-bucks-currency', String(selectedCurrency).trim());

    document.dispatchEvent(new CustomEvent('jsc:bucks:selected-currency', {
      detail: selectedCurrency
    }));

    triggerBucksReConvert();
  };

  document.addEventListener(eventName, handleCurrencyChange);
  window.__jscBucksCurrencyEventBound = true;
};

toggleCartDrawerNotice = () => {
  if (window.__jscCartDrawerNoticeBound) return;
  window.__jscCartDrawerNoticeBound = true;

  var refreshBanner = function() {
    var $banner = $('.jsc-cart-currency-display-banner');
    if (!$banner.length) return;

    var $buckMoney = $('.buckscc-money');
    var buckCurrency = window.jscCurrentBucksCurrency;

    if (!buckCurrency && $buckMoney.length > 0) {
      buckCurrency = $buckMoney.first().attr('bucks-currency');
    }

    if (!buckCurrency || buckCurrency == 'USD') {
      $banner.hide();
    } else {
      $banner.show();
    }
  };

  var refreshBannerAfterRender = function() {
    refreshBanner();
    setTimeout(refreshBanner, 150);
    setTimeout(refreshBanner, 500);
    setTimeout(refreshBanner, 1000);
  };

  refreshBannerAfterRender();

  document.addEventListener('jsc:bucks:selected-currency', function (event) {
    refreshBannerAfterRender();
  });

  document.addEventListener('theme:cart:change', refreshBannerAfterRender);
  document.addEventListener('cart:updated', refreshBannerAfterRender);
  document.addEventListener('theme:cart-drawer:open', refreshBannerAfterRender);
  document.addEventListener('cart-is-open', refreshBannerAfterRender);
}